(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode("._tooltip_5svgn_1{width:260px}._popover_5svgn_5{background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);box-sizing:border-box;z-index:100}._bar_1n5dj_1{overflow:hidden}._section_1n5dj_5{position:relative}._sectionHidden_1n5dj_8{display:none!important}._sectionInheritRadius_1n5dj_11{border-radius:inherit}._valueOutside_1n5dj_15{position:absolute;left:calc(100% + var(--dixa-size-spacer-100));z-index:1}:root{--dixa-analytics-color-default-1: var(--dixa-color-purple-700);--dixa-analytics-color-default-2: var(--dixa-color-blue-300);--dixa-analytics-color-default-3: var(--dixa-color-red-500);--dixa-analytics-color-default-4: var(--dixa-color-orange-300);--dixa-analytics-color-default-5: var(--dixa-color-purple-500);--dixa-analytics-color-default-6: var(--dixa-color-green-400);--dixa-analytics-color-default-7: var(--dixa-color-neutral-600);--dixa-analytics-color-default-8: var(--dixa-color-neutral-400);--dixa-analytics-color-rating-1: var(--dixa-color-red-600);--dixa-analytics-color-rating-2: var(--dixa-color-red-400);--dixa-analytics-color-rating-3: var(--dixa-color-orange-300);--dixa-analytics-color-rating-4: var(--dixa-color-green-500);--dixa-analytics-color-rating-5: var(--dixa-color-green-600)}[data-color-mode=dark]{--dixa-analytics-color-default-1: var(--dixa-color-blue-300);--dixa-analytics-color-default-2: var(--dixa-color-blue-700);--dixa-analytics-color-default-3: var(--dixa-color-red-400);--dixa-analytics-color-default-4: var(--dixa-color-orange-600);--dixa-analytics-color-default-5: var(--dixa-color-purple-500);--dixa-analytics-color-default-6: var(--dixa-color-green-500);--dixa-analytics-color-default-7: var(--dixa-color-neutral-400);--dixa-analytics-color-default-8: var(--dixa-color-neutral-800);--dixa-analytics-color-rating-1: var(--dixa-color-red-400);--dixa-analytics-color-rating-2: var(--dixa-color-red-600);--dixa-analytics-color-rating-3: var(--dixa-color-orange-600);--dixa-analytics-color-rating-4: var(--dixa-color-green-400);--dixa-analytics-color-rating-5: var(--dixa-color-green-300)}._container_1t2a7_1{overflow:hidden}._root_6kwn9_1{display:grid;column-gap:var(--dixa-size-spacer-200);row-gap:var(--dixa-size-spacer-300);white-space:nowrap}._root_6kwn9_1:not(._rootBounded_6kwn9_7):not(._rootFluid_6kwn9_7){grid-template-columns:repeat(auto-fit,minmax(min(100% / 2 - var(--dixa-size-spacer-200) * (2 - 1) / 2,max(96px,100% / 6 - var(--dixa-size-spacer-200) * (6 - 1) / 6)),1fr))}._rootFluid_6kwn9_7,._rootBounded_6kwn9_7{grid-template-columns:repeat(auto-fit,minmax(96px,1fr))}._rootBounded_6kwn9_7{max-width:calc(6 * 96px + var(--dixa-size-spacer-200) * (6 - 1))}._wrapper_1w7q6_1{display:inline-flex;align-self:flex-start}._text_1w7q6_6{font-size:var(--dixa-typography-size-600)}._colorIndicator_luubh_1{width:6px;height:6px;border-radius:50%;flex-shrink:0}._root_7a8ds_48{display:flex;flex-direction:column;gap:var(--dixa-size-spacer-300);padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);box-shadow:var(--dixa-effect-box-shadow-300);background-color:light-dark(var(--dixa-color-neutral-900),var(--dixa-color-neutral-200));color:light-dark(var(--dixa-color-neutral-000),var(--dixa-typography-color-primary))}@supports not (color: light-dark(white,black)){._root_7a8ds_48{background-color:var(--dixa-color-neutral-900)}}@supports not (color: light-dark(white,black)){._root_7a8ds_48{color:var(--dixa-color-neutral-000)}}._legendItem_1mjjb_48{flex-shrink:0;overflow:hidden;white-space:nowrap;cursor:pointer;opacity:1}._legendItemInactive_1mjjb_55{opacity:.4}._legendIcon_1mjjb_59{flex-shrink:0;width:12px;border-radius:var(--dixa-size-border-radius-50);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-sizing:border-box}._legendIconBar_1mjjb_66{height:12px}._legendIconLine_1mjjb_69{height:4px}._trigger_1mrk9_1{width:100%;height:100%}._cell_hfkay_1{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;cursor:default;opacity:1;transition:opacity .2s ease-in-out}._cell_hfkay_1:hover ._cellText_hfkay_11{color:var(--dixa-typography-color-primary)}._cellDimmed_hfkay_14{opacity:var(--dixa-effect-opacity-200)}._cellContent_hfkay_18{display:flex;align-items:center;justify-content:center;width:100%;height:100%}._cellText_hfkay_11{transition:color .2s ease-in-out}._grid_1qk2p_1{display:grid;grid-auto-rows:minmax(var(--dixa-size-spacer-500),1fr);flex-grow:1}._row_1qk2p_7{display:grid;grid-auto-columns:1fr;grid-auto-flow:column;align-items:center;text-align:center}._legend_bx9pd_48{position:relative}._trigger_bx9pd_52{position:absolute;top:-50%;right:0}._popover_bx9pd_58{width:256px;max-height:298px;padding:var(--dixa-size-spacer-300);z-index:100;box-sizing:border-box;background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);margin:0 var(--dixa-size-spacer-200);overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._breakdown_bx9pd_77{display:flex;flex-direction:column;gap:var(--dixa-size-spacer-250);list-style:none;margin:0;padding:0}._breakdown_bx9pd_77 li{display:grid;grid-template-columns:1fr auto;gap:var(--dixa-size-spacer-200)}._breakdown_bx9pd_77 li>:first-child{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_h4i5v_1{max-width:300px}._trigger_h4i5v_5{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0}._tableWrapper_1xmkm_1{overflow:auto}._tableWrapperEmpty_1xmkm_4{flex-grow:1}._thCell_1xmkm_8{white-space:nowrap}._tdCell_1xmkm_12{position:relative;max-width:240px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_1xmkm_20{max-width:300px}")),document.head.appendChild(a)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import * as D from "react";
import no, { useCallback as G, createContext as zi, useMemo as Y, createElement as z, useContext as Pl, forwardRef as be, Children as ut, isValidElement as Zt, cloneElement as cr, Fragment as El, useEffect as ae, useRef as ie, useState as Z, useLayoutEffect as ao, useReducer as ud, memo as we } from "react";
import { IconButton as io, ButtonList as Or, FlexBox as K, Text as W, Tooltip as At, Box as oo, ButtonGroup as Ol, Button as Al, EmptyState as Tl, Divider as ld, Badge as fd, Table as Ce, HelpIcon as dd, Pagination as hd } from "@dixa/lib-shared-habla";
import * as pd from "react-dom";
import vd, { flushSync as $l } from "react-dom";
import $e from "classnames";
import { usePrevious as ql, useInterval as gd, useList as md, useUpdateEffect as Tt, useMap as bd } from "react-use";
import { Sector as ko, LabelList as yd, Cell as Vo, ResponsiveContainer as _d, XAxis as xd, YAxis as wd, CartesianGrid as Cd, ReferenceLine as Rd, Label as Sd, Legend as Pd, Tooltip as Ed, PieChart as Od, AreaChart as Ad, LineChart as Td, BarChart as $d, Line as qd, Bar as jd, Area as Id, Pie as Md } from "recharts";
import lt from "moment-timezone";
import { colors as jl, typography as Dd } from "@dixa/lib-shared-tokens";
import { TagChips as Fd } from "lib-shared-tagging";
var Nt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Re(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Nd(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      var a = !1;
      try {
        a = this instanceof n;
      } catch {
      }
      return a ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Lt = { exports: {} }, bt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bo;
function Ld() {
  if (Bo) return bt;
  Bo = 1;
  var e = no, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, c, u) {
    var d, l = {}, h = null, f = null;
    u !== void 0 && (h = "" + u), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (f = c.ref);
    for (d in c) n.call(c, d) && !i.hasOwnProperty(d) && (l[d] = c[d]);
    if (s && s.defaultProps) for (d in c = s.defaultProps, c) l[d] === void 0 && (l[d] = c[d]);
    return { $$typeof: t, type: s, key: h, ref: f, props: l, _owner: a.current };
  }
  return bt.Fragment = r, bt.jsx = o, bt.jsxs = o, bt;
}
var yt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ho;
function kd() {
  return Ho || (Ho = 1, process.env.NODE_ENV !== "production" && function() {
    var e = no, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), g = Symbol.iterator, p = "@@iterator";
    function m(v) {
      if (v === null || typeof v != "object")
        return null;
      var A = g && v[g] || v[p];
      return typeof A == "function" ? A : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(v) {
      {
        for (var A = arguments.length, j = new Array(A > 1 ? A - 1 : 0), N = 1; N < A; N++)
          j[N - 1] = arguments[N];
        C("error", v, j);
      }
    }
    function C(v, A, j) {
      {
        var N = b.ReactDebugCurrentFrame, H = N.getStackAddendum();
        H !== "" && (A += "%s", j = j.concat([H]));
        var U = j.map(function(B) {
          return String(B);
        });
        U.unshift("Warning: " + A), Function.prototype.apply.call(console[v], console, U);
      }
    }
    var R = !1, P = !1, O = !1, T = !1, x = !1, w;
    w = Symbol.for("react.module.reference");
    function E(v) {
      return !!(typeof v == "string" || typeof v == "function" || v === n || v === i || x || v === a || v === u || v === d || T || v === f || R || P || O || typeof v == "object" && v !== null && (v.$$typeof === h || v.$$typeof === l || v.$$typeof === o || v.$$typeof === s || v.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      v.$$typeof === w || v.getModuleId !== void 0));
    }
    function S(v, A, j) {
      var N = v.displayName;
      if (N)
        return N;
      var H = A.displayName || A.name || "";
      return H !== "" ? j + "(" + H + ")" : j;
    }
    function I(v) {
      return v.displayName || "Context";
    }
    function $(v) {
      if (v == null)
        return null;
      if (typeof v.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof v == "function")
        return v.displayName || v.name || null;
      if (typeof v == "string")
        return v;
      switch (v) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case s:
            var A = v;
            return I(A) + ".Consumer";
          case o:
            var j = v;
            return I(j._context) + ".Provider";
          case c:
            return S(v, v.render, "ForwardRef");
          case l:
            var N = v.displayName || null;
            return N !== null ? N : $(v.type) || "Memo";
          case h: {
            var H = v, U = H._payload, B = H._init;
            try {
              return $(B(U));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, F = 0, q, L, k, Q, re, te, he;
    function oe() {
    }
    oe.__reactDisabledLog = !0;
    function ue() {
      {
        if (F === 0) {
          q = console.log, L = console.info, k = console.warn, Q = console.error, re = console.group, te = console.groupCollapsed, he = console.groupEnd;
          var v = {
            configurable: !0,
            enumerable: !0,
            value: oe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: v,
            log: v,
            warn: v,
            error: v,
            group: v,
            groupCollapsed: v,
            groupEnd: v
          });
        }
        F++;
      }
    }
    function pe() {
      {
        if (F--, F === 0) {
          var v = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, v, {
              value: q
            }),
            info: M({}, v, {
              value: L
            }),
            warn: M({}, v, {
              value: k
            }),
            error: M({}, v, {
              value: Q
            }),
            group: M({}, v, {
              value: re
            }),
            groupCollapsed: M({}, v, {
              value: te
            }),
            groupEnd: M({}, v, {
              value: he
            })
          });
        }
        F < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var X = b.ReactCurrentDispatcher, ve;
    function le(v, A, j) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (H) {
            var N = H.stack.trim().match(/\n( *(at )?)/);
            ve = N && N[1] || "";
          }
        return `
` + ve + v;
      }
    }
    var ne = !1, ye;
    {
      var Ae = typeof WeakMap == "function" ? WeakMap : Map;
      ye = new Ae();
    }
    function Fe(v, A) {
      if (!v || ne)
        return "";
      {
        var j = ye.get(v);
        if (j !== void 0)
          return j;
      }
      var N;
      ne = !0;
      var H = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var U;
      U = X.current, X.current = null, ue();
      try {
        if (A) {
          var B = function() {
            throw Error();
          };
          if (Object.defineProperty(B.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(B, []);
            } catch (de) {
              N = de;
            }
            Reflect.construct(v, [], B);
          } else {
            try {
              B.call();
            } catch (de) {
              N = de;
            }
            v.call(B.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (de) {
            N = de;
          }
          v();
        }
      } catch (de) {
        if (de && N && typeof de.stack == "string") {
          for (var V = de.stack.split(`
`), ce = N.stack.split(`
`), J = V.length - 1, ee = ce.length - 1; J >= 1 && ee >= 0 && V[J] !== ce[ee]; )
            ee--;
          for (; J >= 1 && ee >= 0; J--, ee--)
            if (V[J] !== ce[ee]) {
              if (J !== 1 || ee !== 1)
                do
                  if (J--, ee--, ee < 0 || V[J] !== ce[ee]) {
                    var _e = `
` + V[J].replace(" at new ", " at ");
                    return v.displayName && _e.includes("<anonymous>") && (_e = _e.replace("<anonymous>", v.displayName)), typeof v == "function" && ye.set(v, _e), _e;
                  }
                while (J >= 1 && ee >= 0);
              break;
            }
        }
      } finally {
        ne = !1, X.current = U, pe(), Error.prepareStackTrace = H;
      }
      var nt = v ? v.displayName || v.name : "", ze = nt ? le(nt) : "";
      return typeof v == "function" && ye.set(v, ze), ze;
    }
    function fe(v, A, j) {
      return Fe(v, !1);
    }
    function Te(v) {
      var A = v.prototype;
      return !!(A && A.isReactComponent);
    }
    function se(v, A, j) {
      if (v == null)
        return "";
      if (typeof v == "function")
        return Fe(v, Te(v));
      if (typeof v == "string")
        return le(v);
      switch (v) {
        case u:
          return le("Suspense");
        case d:
          return le("SuspenseList");
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case c:
            return fe(v.render);
          case l:
            return se(v.type, A, j);
          case h: {
            var N = v, H = N._payload, U = N._init;
            try {
              return se(U(H), A, j);
            } catch {
            }
          }
        }
      return "";
    }
    var Ne = Object.prototype.hasOwnProperty, Dt = {}, Ft = b.ReactDebugCurrentFrame;
    function et(v) {
      if (v) {
        var A = v._owner, j = se(v.type, v._source, A ? A.type : null);
        Ft.setExtraStackFrame(j);
      } else
        Ft.setExtraStackFrame(null);
    }
    function wr(v, A, j, N, H) {
      {
        var U = Function.call.bind(Ne);
        for (var B in v)
          if (U(v, B)) {
            var V = void 0;
            try {
              if (typeof v[B] != "function") {
                var ce = Error((N || "React class") + ": " + j + " type `" + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[B] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ce.name = "Invariant Violation", ce;
              }
              V = v[B](A, B, N, j, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (J) {
              V = J;
            }
            V && !(V instanceof Error) && (et(H), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", N || "React class", j, B, typeof V), et(null)), V instanceof Error && !(V.message in Dt) && (Dt[V.message] = !0, et(H), _("Failed %s type: %s", j, V.message), et(null));
          }
      }
    }
    var tt = Array.isArray;
    function Cr(v) {
      return tt(v);
    }
    function Hf(v) {
      {
        var A = typeof Symbol == "function" && Symbol.toStringTag, j = A && v[Symbol.toStringTag] || v.constructor.name || "Object";
        return j;
      }
    }
    function zf(v) {
      try {
        return Oo(v), !1;
      } catch {
        return !0;
      }
    }
    function Oo(v) {
      return "" + v;
    }
    function Ao(v) {
      if (zf(v))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Hf(v)), Oo(v);
    }
    var To = b.ReactCurrentOwner, Uf = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, $o, qo;
    function Wf(v) {
      if (Ne.call(v, "ref")) {
        var A = Object.getOwnPropertyDescriptor(v, "ref").get;
        if (A && A.isReactWarning)
          return !1;
      }
      return v.ref !== void 0;
    }
    function Gf(v) {
      if (Ne.call(v, "key")) {
        var A = Object.getOwnPropertyDescriptor(v, "key").get;
        if (A && A.isReactWarning)
          return !1;
      }
      return v.key !== void 0;
    }
    function Kf(v, A) {
      typeof v.ref == "string" && To.current;
    }
    function Yf(v, A) {
      {
        var j = function() {
          $o || ($o = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", A));
        };
        j.isReactWarning = !0, Object.defineProperty(v, "key", {
          get: j,
          configurable: !0
        });
      }
    }
    function Xf(v, A) {
      {
        var j = function() {
          qo || (qo = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", A));
        };
        j.isReactWarning = !0, Object.defineProperty(v, "ref", {
          get: j,
          configurable: !0
        });
      }
    }
    var Jf = function(v, A, j, N, H, U, B) {
      var V = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: v,
        key: A,
        ref: j,
        props: B,
        // Record the component responsible for creating this element.
        _owner: U
      };
      return V._store = {}, Object.defineProperty(V._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(V, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: N
      }), Object.defineProperty(V, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: H
      }), Object.freeze && (Object.freeze(V.props), Object.freeze(V)), V;
    };
    function Zf(v, A, j, N, H) {
      {
        var U, B = {}, V = null, ce = null;
        j !== void 0 && (Ao(j), V = "" + j), Gf(A) && (Ao(A.key), V = "" + A.key), Wf(A) && (ce = A.ref, Kf(A, H));
        for (U in A)
          Ne.call(A, U) && !Uf.hasOwnProperty(U) && (B[U] = A[U]);
        if (v && v.defaultProps) {
          var J = v.defaultProps;
          for (U in J)
            B[U] === void 0 && (B[U] = J[U]);
        }
        if (V || ce) {
          var ee = typeof v == "function" ? v.displayName || v.name || "Unknown" : v;
          V && Yf(B, ee), ce && Xf(B, ee);
        }
        return Jf(v, V, ce, H, N, To.current, B);
      }
    }
    var Rr = b.ReactCurrentOwner, jo = b.ReactDebugCurrentFrame;
    function rt(v) {
      if (v) {
        var A = v._owner, j = se(v.type, v._source, A ? A.type : null);
        jo.setExtraStackFrame(j);
      } else
        jo.setExtraStackFrame(null);
    }
    var Sr;
    Sr = !1;
    function Pr(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }
    function Io() {
      {
        if (Rr.current) {
          var v = $(Rr.current.type);
          if (v)
            return `

Check the render method of \`` + v + "`.";
        }
        return "";
      }
    }
    function Qf(v) {
      return "";
    }
    var Mo = {};
    function ed(v) {
      {
        var A = Io();
        if (!A) {
          var j = typeof v == "string" ? v : v.displayName || v.name;
          j && (A = `

Check the top-level render call using <` + j + ">.");
        }
        return A;
      }
    }
    function Do(v, A) {
      {
        if (!v._store || v._store.validated || v.key != null)
          return;
        v._store.validated = !0;
        var j = ed(A);
        if (Mo[j])
          return;
        Mo[j] = !0;
        var N = "";
        v && v._owner && v._owner !== Rr.current && (N = " It was passed a child from " + $(v._owner.type) + "."), rt(v), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', j, N), rt(null);
      }
    }
    function Fo(v, A) {
      {
        if (typeof v != "object")
          return;
        if (Cr(v))
          for (var j = 0; j < v.length; j++) {
            var N = v[j];
            Pr(N) && Do(N, A);
          }
        else if (Pr(v))
          v._store && (v._store.validated = !0);
        else if (v) {
          var H = m(v);
          if (typeof H == "function" && H !== v.entries)
            for (var U = H.call(v), B; !(B = U.next()).done; )
              Pr(B.value) && Do(B.value, A);
        }
      }
    }
    function td(v) {
      {
        var A = v.type;
        if (A == null || typeof A == "string")
          return;
        var j;
        if (typeof A == "function")
          j = A.propTypes;
        else if (typeof A == "object" && (A.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        A.$$typeof === l))
          j = A.propTypes;
        else
          return;
        if (j) {
          var N = $(A);
          wr(j, v.props, "prop", N, v);
        } else if (A.PropTypes !== void 0 && !Sr) {
          Sr = !0;
          var H = $(A);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", H || "Unknown");
        }
        typeof A.getDefaultProps == "function" && !A.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function rd(v) {
      {
        for (var A = Object.keys(v.props), j = 0; j < A.length; j++) {
          var N = A[j];
          if (N !== "children" && N !== "key") {
            rt(v), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", N), rt(null);
            break;
          }
        }
        v.ref !== null && (rt(v), _("Invalid attribute `ref` supplied to `React.Fragment`."), rt(null));
      }
    }
    var No = {};
    function Lo(v, A, j, N, H, U) {
      {
        var B = E(v);
        if (!B) {
          var V = "";
          (v === void 0 || typeof v == "object" && v !== null && Object.keys(v).length === 0) && (V += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ce = Qf();
          ce ? V += ce : V += Io();
          var J;
          v === null ? J = "null" : Cr(v) ? J = "array" : v !== void 0 && v.$$typeof === t ? (J = "<" + ($(v.type) || "Unknown") + " />", V = " Did you accidentally export a JSX literal instead of a component?") : J = typeof v, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", J, V);
        }
        var ee = Zf(v, A, j, H, U);
        if (ee == null)
          return ee;
        if (B) {
          var _e = A.children;
          if (_e !== void 0)
            if (N)
              if (Cr(_e)) {
                for (var nt = 0; nt < _e.length; nt++)
                  Fo(_e[nt], v);
                Object.freeze && Object.freeze(_e);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Fo(_e, v);
        }
        if (Ne.call(A, "key")) {
          var ze = $(v), de = Object.keys(A).filter(function(cd) {
            return cd !== "key";
          }), Er = de.length > 0 ? "{key: someKey, " + de.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!No[ze + Er]) {
            var sd = de.length > 0 ? "{" + de.join(": ..., ") + ": ...}" : "{}";
            _(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Er, ze, sd, ze), No[ze + Er] = !0;
          }
        }
        return v === n ? rd(ee) : td(ee), ee;
      }
    }
    function nd(v, A, j) {
      return Lo(v, A, j, !0);
    }
    function ad(v, A, j) {
      return Lo(v, A, j, !1);
    }
    var id = ad, od = nd;
    yt.Fragment = n, yt.jsx = id, yt.jsxs = od;
  }()), yt;
}
var zo;
function Vd() {
  return zo || (zo = 1, process.env.NODE_ENV === "production" ? Lt.exports = Ld() : Lt.exports = kd()), Lt.exports;
}
var y = Vd();
function qe() {
  return qe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qe.apply(this, arguments);
}
function Ue(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e?.(a), r === !1 || !a.defaultPrevented) return t?.(a);
  };
}
function Bd(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Il(...e) {
  return (t) => e.forEach(
    (r) => Bd(r, t)
  );
}
function Ye(...e) {
  return G(Il(...e), e);
}
function Ml(e, t = []) {
  let r = [];
  function n(i, o) {
    const s = /* @__PURE__ */ zi(o), c = r.length;
    r = [
      ...r,
      o
    ];
    function u(l) {
      const { scope: h, children: f, ...g } = l, p = h?.[e][c] || s, m = Y(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ z(p.Provider, {
        value: m
      }, f);
    }
    function d(l, h) {
      const f = h?.[e][c] || s, g = Pl(f);
      if (g) return g;
      if (o !== void 0) return o;
      throw new Error(`\`${l}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [
      u,
      d
    ];
  }
  const a = () => {
    const i = r.map((o) => /* @__PURE__ */ zi(o));
    return function(s) {
      const c = s?.[e] || i;
      return Y(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    n,
    Hd(a, ...t)
  ];
}
function Hd(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = n.reduce((s, { useScope: c, scopeName: u }) => {
        const l = c(i)[`__scope${u}`];
        return {
          ...s,
          ...l
        };
      }, {});
      return Y(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return r.scopeName = t.scopeName, r;
}
function Ui() {
  return Ui = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ui.apply(this, arguments);
}
function Wi() {
  return Wi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wi.apply(this, arguments);
}
function Qt() {
  return Qt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qt.apply(this, arguments);
}
const so = /* @__PURE__ */ be((e, t) => {
  const { children: r, ...n } = e, a = ut.toArray(r), i = a.find(Ud);
  if (i) {
    const o = i.props.children, s = a.map((c) => c === i ? ut.count(o) > 1 ? ut.only(null) : /* @__PURE__ */ Zt(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z(Gi, Qt({}, n, {
      ref: t
    }), /* @__PURE__ */ Zt(o) ? /* @__PURE__ */ cr(o, void 0, s) : null);
  }
  return /* @__PURE__ */ z(Gi, Qt({}, n, {
    ref: t
  }), r);
});
so.displayName = "Slot";
const Gi = /* @__PURE__ */ be((e, t) => {
  const { children: r, ...n } = e;
  return /* @__PURE__ */ Zt(r) ? /* @__PURE__ */ cr(r, {
    ...Wd(n, r.props),
    ref: t ? Il(t, r.ref) : r.ref
  }) : ut.count(r) > 1 ? ut.only(null) : null;
});
Gi.displayName = "SlotClone";
const zd = ({ children: e }) => /* @__PURE__ */ z(El, null, e);
function Ud(e) {
  return /* @__PURE__ */ Zt(e) && e.type === zd;
}
function Wd(e, t) {
  const r = {
    ...t
  };
  for (const n in t) {
    const a = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...s) => {
      i(...s), a(...s);
    } : a && (r[n] = a) : n === "style" ? r[n] = {
      ...a,
      ...i
    } : n === "className" && (r[n] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...r
  };
}
const Gd = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], pt = Gd.reduce((e, t) => {
  const r = /* @__PURE__ */ be((n, a) => {
    const { asChild: i, ...o } = n, s = i ? so : t;
    return ae(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ z(s, Wi({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function Kd(e, t) {
  e && $l(
    () => e.dispatchEvent(t)
  );
}
function ke(e) {
  const t = ie(e);
  return ae(() => {
    t.current = e;
  }), Y(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
function Yd(e, t = globalThis?.document) {
  const r = ke(e);
  ae(() => {
    const n = (a) => {
      a.key === "Escape" && r(a);
    };
    return t.addEventListener("keydown", n), () => t.removeEventListener("keydown", n);
  }, [
    r,
    t
  ]);
}
const Ki = "dismissableLayer.update", Xd = "dismissableLayer.pointerDownOutside", Jd = "dismissableLayer.focusOutside";
let Uo;
const Zd = /* @__PURE__ */ zi({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Qd = /* @__PURE__ */ be((e, t) => {
  var r;
  const { disableOutsidePointerEvents: n = !1, onEscapeKeyDown: a, onPointerDownOutside: i, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...u } = e, d = Pl(Zd), [l, h] = Z(null), f = (r = l?.ownerDocument) !== null && r !== void 0 ? r : globalThis?.document, [, g] = Z({}), p = Ye(
    t,
    (x) => h(x)
  ), m = Array.from(d.layers), [b] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), _ = m.indexOf(b), C = l ? m.indexOf(l) : -1, R = d.layersWithOutsidePointerEventsDisabled.size > 0, P = C >= _, O = eh((x) => {
    const w = x.target, E = [
      ...d.branches
    ].some(
      (S) => S.contains(w)
    );
    !P || E || (i?.(x), s?.(x), x.defaultPrevented || c?.());
  }, f), T = th((x) => {
    const w = x.target;
    [
      ...d.branches
    ].some(
      (S) => S.contains(w)
    ) || (o?.(x), s?.(x), x.defaultPrevented || c?.());
  }, f);
  return Yd((x) => {
    C === d.layers.size - 1 && (a?.(x), !x.defaultPrevented && c && (x.preventDefault(), c()));
  }, f), ae(() => {
    if (l)
      return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Uo = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(l)), d.layers.add(l), Wo(), () => {
        n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = Uo);
      };
  }, [
    l,
    f,
    n,
    d
  ]), ae(() => () => {
    l && (d.layers.delete(l), d.layersWithOutsidePointerEventsDisabled.delete(l), Wo());
  }, [
    l,
    d
  ]), ae(() => {
    const x = () => g({});
    return document.addEventListener(Ki, x), () => document.removeEventListener(Ki, x);
  }, []), /* @__PURE__ */ z(pt.div, Ui({}, u, {
    ref: p,
    style: {
      pointerEvents: R ? P ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Ue(e.onFocusCapture, T.onFocusCapture),
    onBlurCapture: Ue(e.onBlurCapture, T.onBlurCapture),
    onPointerDownCapture: Ue(e.onPointerDownCapture, O.onPointerDownCapture)
  }));
});
function eh(e, t = globalThis?.document) {
  const r = ke(e), n = ie(!1), a = ie(() => {
  });
  return ae(() => {
    const i = (s) => {
      if (s.target && !n.current) {
        let u = function() {
          Dl(Xd, r, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = u, t.addEventListener("click", a.current, {
          once: !0
        })) : u();
      } else
        t.removeEventListener("click", a.current);
      n.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [
    t,
    r
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function th(e, t = globalThis?.document) {
  const r = ke(e), n = ie(!1);
  return ae(() => {
    const a = (i) => {
      i.target && !n.current && Dl(Jd, r, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [
    t,
    r
  ]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Wo() {
  const e = new CustomEvent(Ki);
  document.dispatchEvent(e);
}
function Dl(e, t, r, { discrete: n }) {
  const a = r.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: r
  });
  t && a.addEventListener(e, t, {
    once: !0
  }), n ? Kd(a, i) : a.dispatchEvent(i);
}
let Ar = 0;
function rh() {
  ae(() => {
    var e, t;
    const r = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = r[0]) !== null && e !== void 0 ? e : Go()), document.body.insertAdjacentElement("beforeend", (t = r[1]) !== null && t !== void 0 ? t : Go()), Ar++, () => {
      Ar === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (n) => n.remove()
      ), Ar--;
    };
  }, []);
}
function Go() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
function Yi() {
  return Yi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yi.apply(this, arguments);
}
const Tr = "focusScope.autoFocusOnMount", $r = "focusScope.autoFocusOnUnmount", Ko = {
  bubbles: !1,
  cancelable: !0
}, nh = /* @__PURE__ */ be((e, t) => {
  const { loop: r = !1, trapped: n = !1, onMountAutoFocus: a, onUnmountAutoFocus: i, ...o } = e, [s, c] = Z(null), u = ke(a), d = ke(i), l = ie(null), h = Ye(
    t,
    (p) => c(p)
  ), f = ie({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ae(() => {
    if (n) {
      let p = function(C) {
        if (f.paused || !s) return;
        const R = C.target;
        s.contains(R) ? l.current = R : Le(l.current, {
          select: !0
        });
      }, m = function(C) {
        if (f.paused || !s) return;
        const R = C.relatedTarget;
        R !== null && (s.contains(R) || Le(l.current, {
          select: !0
        }));
      }, b = function(C) {
        if (document.activeElement === document.body)
          for (const P of C) P.removedNodes.length > 0 && Le(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", m);
      const _ = new MutationObserver(b);
      return s && _.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", m), _.disconnect();
      };
    }
  }, [
    n,
    s,
    f.paused
  ]), ae(() => {
    if (s) {
      Xo.add(f);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const b = new CustomEvent(Tr, Ko);
        s.addEventListener(Tr, u), s.dispatchEvent(b), b.defaultPrevented || (ah(uh(Fl(s)), {
          select: !0
        }), document.activeElement === p && Le(s));
      }
      return () => {
        s.removeEventListener(Tr, u), setTimeout(() => {
          const b = new CustomEvent($r, Ko);
          s.addEventListener($r, d), s.dispatchEvent(b), b.defaultPrevented || Le(p ?? document.body, {
            select: !0
          }), s.removeEventListener($r, d), Xo.remove(f);
        }, 0);
      };
    }
  }, [
    s,
    u,
    d,
    f
  ]);
  const g = G((p) => {
    if (!r && !n || f.paused) return;
    const m = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, b = document.activeElement;
    if (m && b) {
      const _ = p.currentTarget, [C, R] = ih(_);
      C && R ? !p.shiftKey && b === R ? (p.preventDefault(), r && Le(C, {
        select: !0
      })) : p.shiftKey && b === C && (p.preventDefault(), r && Le(R, {
        select: !0
      })) : b === _ && p.preventDefault();
    }
  }, [
    r,
    n,
    f.paused
  ]);
  return /* @__PURE__ */ z(pt.div, Yi({
    tabIndex: -1
  }, o, {
    ref: h,
    onKeyDown: g
  }));
});
function ah(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (Le(n, {
      select: t
    }), document.activeElement !== r) return;
}
function ih(e) {
  const t = Fl(e), r = Yo(t, e), n = Yo(t.reverse(), e);
  return [
    r,
    n
  ];
}
function Fl(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Yo(e, t) {
  for (const r of e)
    if (!oh(r, {
      upTo: t
    })) return r;
}
function oh(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function sh(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Le(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== r && sh(e) && t && e.select();
  }
}
const Xo = ch();
function ch() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && r?.pause(), e = Jo(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = Jo(e, t), (r = e[0]) === null || r === void 0 || r.resume();
    }
  };
}
function Jo(e, t) {
  const r = [
    ...e
  ], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function uh(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const dt = globalThis?.document ? ao : () => {
}, lh = D.useId || (() => {
});
let fh = 0;
function dh(e) {
  const [t, r] = D.useState(lh());
  return dt(() => {
    r(
      (n) => n ?? String(fh++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function er() {
  return er = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, er.apply(this, arguments);
}
const hh = ["top", "right", "bottom", "left"], Ve = Math.min, ge = Math.max, tr = Math.round, kt = Math.floor, Be = (e) => ({
  x: e,
  y: e
}), ph = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, vh = {
  start: "end",
  end: "start"
};
function Xi(e, t, r) {
  return ge(e, Ve(t, r));
}
function je(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ie(e) {
  return e.split("-")[0];
}
function vt(e) {
  return e.split("-")[1];
}
function co(e) {
  return e === "x" ? "y" : "x";
}
function uo(e) {
  return e === "y" ? "height" : "width";
}
function gt(e) {
  return ["top", "bottom"].includes(Ie(e)) ? "y" : "x";
}
function lo(e) {
  return co(gt(e));
}
function gh(e, t, r) {
  r === void 0 && (r = !1);
  const n = vt(e), a = lo(e), i = uo(a);
  let o = a === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = rr(o)), [o, rr(o)];
}
function mh(e) {
  const t = rr(e);
  return [Ji(e), t, Ji(t)];
}
function Ji(e) {
  return e.replace(/start|end/g, (t) => vh[t]);
}
function bh(e, t, r) {
  const n = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? a : n : t ? n : a;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function yh(e, t, r, n) {
  const a = vt(e);
  let i = bh(Ie(e), r === "start", n);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map(Ji)))), i;
}
function rr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => ph[t]);
}
function _h(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Nl(e) {
  return typeof e != "number" ? _h(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function nr(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Zo(e, t, r) {
  let {
    reference: n,
    floating: a
  } = e;
  const i = gt(t), o = lo(t), s = uo(o), c = Ie(t), u = i === "y", d = n.x + n.width / 2 - a.width / 2, l = n.y + n.height / 2 - a.height / 2, h = n[s] / 2 - a[s] / 2;
  let f;
  switch (c) {
    case "top":
      f = {
        x: d,
        y: n.y - a.height
      };
      break;
    case "bottom":
      f = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: l
      };
      break;
    case "left":
      f = {
        x: n.x - a.width,
        y: l
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (vt(t)) {
    case "start":
      f[o] -= h * (r && u ? -1 : 1);
      break;
    case "end":
      f[o] += h * (r && u ? -1 : 1);
      break;
  }
  return f;
}
const xh = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = r, s = i.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: d,
    y: l
  } = Zo(u, n, c), h = n, f = {}, g = 0;
  for (let p = 0; p < s.length; p++) {
    const {
      name: m,
      fn: b
    } = s[p], {
      x: _,
      y: C,
      data: R,
      reset: P
    } = await b({
      x: d,
      y: l,
      initialPlacement: n,
      placement: h,
      strategy: a,
      middlewareData: f,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (d = _ ?? d, l = C ?? l, f = {
      ...f,
      [m]: {
        ...f[m],
        ...R
      }
    }, P && g <= 50) {
      g++, typeof P == "object" && (P.placement && (h = P.placement), P.rects && (u = P.rects === !0 ? await o.getElementRects({
        reference: e,
        floating: t,
        strategy: a
      }) : P.rects), {
        x: d,
        y: l
      } = Zo(u, h, c)), p = -1;
      continue;
    }
  }
  return {
    x: d,
    y: l,
    placement: h,
    strategy: a,
    middlewareData: f
  };
};
async function Pt(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: a,
    platform: i,
    rects: o,
    elements: s,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: l = "floating",
    altBoundary: h = !1,
    padding: f = 0
  } = je(t, e), g = Nl(f), m = s[h ? l === "floating" ? "reference" : "floating" : l], b = nr(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(m))) == null || r ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: c
  })), _ = l === "floating" ? {
    ...o.floating,
    x: n,
    y: a
  } : o.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), R = await (i.isElement == null ? void 0 : i.isElement(C)) ? await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, P = nr(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: _,
    offsetParent: C,
    strategy: c
  }) : _);
  return {
    top: (b.top - P.top + g.top) / R.y,
    bottom: (P.bottom - b.bottom + g.bottom) / R.y,
    left: (b.left - P.left + g.left) / R.x,
    right: (P.right - b.right + g.right) / R.x
  };
}
const Qo = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: a,
      rects: i,
      platform: o,
      elements: s
    } = t, {
      element: c,
      padding: u = 0
    } = je(e, t) || {};
    if (c == null)
      return {};
    const d = Nl(u), l = {
      x: r,
      y: n
    }, h = lo(a), f = uo(h), g = await o.getDimensions(c), p = h === "y", m = p ? "top" : "left", b = p ? "bottom" : "right", _ = p ? "clientHeight" : "clientWidth", C = i.reference[f] + i.reference[h] - l[h] - i.floating[f], R = l[h] - i.reference[h], P = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let O = P ? P[_] : 0;
    (!O || !await (o.isElement == null ? void 0 : o.isElement(P))) && (O = s.floating[_] || i.floating[f]);
    const T = C / 2 - R / 2, x = O / 2 - g[f] / 2 - 1, w = Ve(d[m], x), E = Ve(d[b], x), S = w, I = O - g[f] - E, $ = O / 2 - g[f] / 2 + T, M = Xi(S, $, I), q = vt(a) != null && $ != M && i.reference[f] / 2 - ($ < S ? w : E) - g[f] / 2 < 0 ? $ < S ? S - $ : I - $ : 0;
    return {
      [h]: l[h] - q,
      data: {
        [h]: M,
        centerOffset: $ - M + q
      }
    };
  }
}), wh = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r;
      const {
        placement: n,
        middlewareData: a,
        rects: i,
        initialPlacement: o,
        platform: s,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: l,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: f = "none",
        flipAlignment: g = !0,
        ...p
      } = je(e, t), m = Ie(n), b = Ie(o) === o, _ = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), C = l || (b || !g ? [rr(o)] : mh(o));
      !l && f !== "none" && C.push(...yh(o, g, f, _));
      const R = [o, ...C], P = await Pt(t, p), O = [];
      let T = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (u && O.push(P[m]), d) {
        const S = gh(n, i, _);
        O.push(P[S[0]], P[S[1]]);
      }
      if (T = [...T, {
        placement: n,
        overflows: O
      }], !O.every((S) => S <= 0)) {
        var x, w;
        const S = (((x = a.flip) == null ? void 0 : x.index) || 0) + 1, I = R[S];
        if (I)
          return {
            data: {
              index: S,
              overflows: T
            },
            reset: {
              placement: I
            }
          };
        let $ = (w = T.filter((M) => M.overflows[0] <= 0).sort((M, F) => M.overflows[1] - F.overflows[1])[0]) == null ? void 0 : w.placement;
        if (!$)
          switch (h) {
            case "bestFit": {
              var E;
              const M = (E = T.map((F) => [F.placement, F.overflows.filter((q) => q > 0).reduce((q, L) => q + L, 0)]).sort((F, q) => F[1] - q[1])[0]) == null ? void 0 : E[0];
              M && ($ = M);
              break;
            }
            case "initialPlacement":
              $ = o;
              break;
          }
        if (n !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function es(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ts(e) {
  return hh.some((t) => e[t] >= 0);
}
const Ch = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...a
      } = je(e, t);
      switch (n) {
        case "referenceHidden": {
          const i = await Pt(t, {
            ...a,
            elementContext: "reference"
          }), o = es(i, r.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: ts(o)
            }
          };
        }
        case "escaped": {
          const i = await Pt(t, {
            ...a,
            altBoundary: !0
          }), o = es(i, r.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: ts(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Rh(e, t) {
  const {
    placement: r,
    platform: n,
    elements: a
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), o = Ie(r), s = vt(r), c = gt(r) === "y", u = ["left", "top"].includes(o) ? -1 : 1, d = i && c ? -1 : 1, l = je(t, e);
  let {
    mainAxis: h,
    crossAxis: f,
    alignmentAxis: g
  } = typeof l == "number" ? {
    mainAxis: l,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...l
  };
  return s && typeof g == "number" && (f = s === "end" ? g * -1 : g), c ? {
    x: f * d,
    y: h * u
  } : {
    x: h * u,
    y: f * d
  };
}
const Sh = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n
      } = t, a = await Rh(t, e);
      return {
        x: r + a.x,
        y: n + a.y,
        data: a
      };
    }
  };
}, Ph = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (m) => {
            let {
              x: b,
              y: _
            } = m;
            return {
              x: b,
              y: _
            };
          }
        },
        ...c
      } = je(e, t), u = {
        x: r,
        y: n
      }, d = await Pt(t, c), l = gt(Ie(a)), h = co(l);
      let f = u[h], g = u[l];
      if (i) {
        const m = h === "y" ? "top" : "left", b = h === "y" ? "bottom" : "right", _ = f + d[m], C = f - d[b];
        f = Xi(_, f, C);
      }
      if (o) {
        const m = l === "y" ? "top" : "left", b = l === "y" ? "bottom" : "right", _ = g + d[m], C = g - d[b];
        g = Xi(_, g, C);
      }
      const p = s.fn({
        ...t,
        [h]: f,
        [l]: g
      });
      return {
        ...p,
        data: {
          x: p.x - r,
          y: p.y - n
        }
      };
    }
  };
}, Eh = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: a,
        rects: i,
        middlewareData: o
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = je(e, t), d = {
        x: r,
        y: n
      }, l = gt(a), h = co(l);
      let f = d[h], g = d[l];
      const p = je(s, t), m = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (c) {
        const C = h === "y" ? "height" : "width", R = i.reference[h] - i.floating[C] + m.mainAxis, P = i.reference[h] + i.reference[C] - m.mainAxis;
        f < R ? f = R : f > P && (f = P);
      }
      if (u) {
        var b, _;
        const C = h === "y" ? "width" : "height", R = ["top", "left"].includes(Ie(a)), P = i.reference[l] - i.floating[C] + (R && ((b = o.offset) == null ? void 0 : b[l]) || 0) + (R ? 0 : m.crossAxis), O = i.reference[l] + i.reference[C] + (R ? 0 : ((_ = o.offset) == null ? void 0 : _[l]) || 0) - (R ? m.crossAxis : 0);
        g < P ? g = P : g > O && (g = O);
      }
      return {
        [h]: f,
        [l]: g
      };
    }
  };
}, Oh = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: r,
        rects: n,
        platform: a,
        elements: i
      } = t, {
        apply: o = () => {
        },
        ...s
      } = je(e, t), c = await Pt(t, s), u = Ie(r), d = vt(r), l = gt(r) === "y", {
        width: h,
        height: f
      } = n.floating;
      let g, p;
      u === "top" || u === "bottom" ? (g = u, p = d === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (p = u, g = d === "end" ? "top" : "bottom");
      const m = f - c[g], b = h - c[p], _ = !t.middlewareData.shift;
      let C = m, R = b;
      if (l) {
        const O = h - c.left - c.right;
        R = d || _ ? Ve(b, O) : O;
      } else {
        const O = f - c.top - c.bottom;
        C = d || _ ? Ve(m, O) : O;
      }
      if (_ && !d) {
        const O = ge(c.left, 0), T = ge(c.right, 0), x = ge(c.top, 0), w = ge(c.bottom, 0);
        l ? R = h - 2 * (O !== 0 || T !== 0 ? O + T : ge(c.left, c.right)) : C = f - 2 * (x !== 0 || w !== 0 ? x + w : ge(c.top, c.bottom));
      }
      await o({
        ...t,
        availableWidth: R,
        availableHeight: C
      });
      const P = await a.getDimensions(i.floating);
      return h !== P.width || f !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function He(e) {
  return Ll(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function me(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function De(e) {
  var t;
  return (t = (Ll(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ll(e) {
  return e instanceof Node || e instanceof me(e).Node;
}
function Me(e) {
  return e instanceof Element || e instanceof me(e).Element;
}
function Ee(e) {
  return e instanceof HTMLElement || e instanceof me(e).HTMLElement;
}
function rs(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof me(e).ShadowRoot;
}
function $t(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: a
  } = xe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(a);
}
function Ah(e) {
  return ["table", "td", "th"].includes(He(e));
}
function fo(e) {
  const t = ho(), r = xe(e);
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function Th(e) {
  let t = ht(e);
  for (; Ee(t) && !ur(t); ) {
    if (fo(t))
      return t;
    t = ht(t);
  }
  return null;
}
function ho() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ur(e) {
  return ["html", "body", "#document"].includes(He(e));
}
function xe(e) {
  return me(e).getComputedStyle(e);
}
function lr(e) {
  return Me(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ht(e) {
  if (He(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    rs(e) && e.host || // Fallback.
    De(e)
  );
  return rs(t) ? t.host : t;
}
function kl(e) {
  const t = ht(e);
  return ur(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ee(t) && $t(t) ? t : kl(t);
}
function ar(e, t) {
  var r;
  t === void 0 && (t = []);
  const n = kl(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = me(n);
  return a ? t.concat(i, i.visualViewport || [], $t(n) ? n : []) : t.concat(n, ar(n));
}
function Vl(e) {
  const t = xe(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const a = Ee(e), i = a ? e.offsetWidth : r, o = a ? e.offsetHeight : n, s = tr(r) !== i || tr(n) !== o;
  return s && (r = i, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function po(e) {
  return Me(e) ? e : e.contextElement;
}
function ft(e) {
  const t = po(e);
  if (!Ee(t))
    return Be(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: a,
    $: i
  } = Vl(t);
  let o = (i ? tr(r.width) : r.width) / n, s = (i ? tr(r.height) : r.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const $h = /* @__PURE__ */ Be(0);
function Bl(e) {
  const t = me(e);
  return !ho() || !t.visualViewport ? $h : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function qh(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== me(e) ? !1 : t;
}
function Ke(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const a = e.getBoundingClientRect(), i = po(e);
  let o = Be(1);
  t && (n ? Me(n) && (o = ft(n)) : o = ft(e));
  const s = qh(i, r, n) ? Bl(i) : Be(0);
  let c = (a.left + s.x) / o.x, u = (a.top + s.y) / o.y, d = a.width / o.x, l = a.height / o.y;
  if (i) {
    const h = me(i), f = n && Me(n) ? me(n) : n;
    let g = h.frameElement;
    for (; g && n && f !== h; ) {
      const p = ft(g), m = g.getBoundingClientRect(), b = xe(g), _ = m.left + (g.clientLeft + parseFloat(b.paddingLeft)) * p.x, C = m.top + (g.clientTop + parseFloat(b.paddingTop)) * p.y;
      c *= p.x, u *= p.y, d *= p.x, l *= p.y, c += _, u += C, g = me(g).frameElement;
    }
  }
  return nr({
    width: d,
    height: l,
    x: c,
    y: u
  });
}
function jh(e) {
  let {
    rect: t,
    offsetParent: r,
    strategy: n
  } = e;
  const a = Ee(r), i = De(r);
  if (r === i)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = Be(1);
  const c = Be(0);
  if ((a || !a && n !== "fixed") && ((He(r) !== "body" || $t(i)) && (o = lr(r)), Ee(r))) {
    const u = Ke(r);
    s = ft(r), c.x = u.x + r.clientLeft, c.y = u.y + r.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - o.scrollLeft * s.x + c.x,
    y: t.y * s.y - o.scrollTop * s.y + c.y
  };
}
function Ih(e) {
  return Array.from(e.getClientRects());
}
function Hl(e) {
  return Ke(De(e)).left + lr(e).scrollLeft;
}
function Mh(e) {
  const t = De(e), r = lr(e), n = e.ownerDocument.body, a = ge(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = ge(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + Hl(e);
  const s = -r.scrollTop;
  return xe(n).direction === "rtl" && (o += ge(t.clientWidth, n.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: s
  };
}
function Dh(e, t) {
  const r = me(e), n = De(e), a = r.visualViewport;
  let i = n.clientWidth, o = n.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, o = a.height;
    const u = ho();
    (!u || u && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s,
    y: c
  };
}
function Fh(e, t) {
  const r = Ke(e, !0, t === "fixed"), n = r.top + e.clientTop, a = r.left + e.clientLeft, i = Ee(e) ? ft(e) : Be(1), o = e.clientWidth * i.x, s = e.clientHeight * i.y, c = a * i.x, u = n * i.y;
  return {
    width: o,
    height: s,
    x: c,
    y: u
  };
}
function ns(e, t, r) {
  let n;
  if (t === "viewport")
    n = Dh(e, r);
  else if (t === "document")
    n = Mh(De(e));
  else if (Me(t))
    n = Fh(t, r);
  else {
    const a = Bl(e);
    n = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return nr(n);
}
function zl(e, t) {
  const r = ht(e);
  return r === t || !Me(r) || ur(r) ? !1 : xe(r).position === "fixed" || zl(r, t);
}
function Nh(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = ar(e).filter((s) => Me(s) && He(s) !== "body"), a = null;
  const i = xe(e).position === "fixed";
  let o = i ? ht(e) : e;
  for (; Me(o) && !ur(o); ) {
    const s = xe(o), c = fo(o);
    !c && s.position === "fixed" && (a = null), (i ? !c && !a : !c && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || $t(o) && !c && zl(e, o)) ? n = n.filter((d) => d !== o) : a = s, o = ht(o);
  }
  return t.set(e, n), n;
}
function Lh(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: a
  } = e;
  const o = [...r === "clippingAncestors" ? Nh(t, this._c) : [].concat(r), n], s = o[0], c = o.reduce((u, d) => {
    const l = ns(t, d, a);
    return u.top = ge(l.top, u.top), u.right = Ve(l.right, u.right), u.bottom = Ve(l.bottom, u.bottom), u.left = ge(l.left, u.left), u;
  }, ns(t, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function kh(e) {
  return Vl(e);
}
function Vh(e, t, r) {
  const n = Ee(t), a = De(t), i = r === "fixed", o = Ke(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Be(0);
  if (n || !n && !i)
    if ((He(t) !== "body" || $t(a)) && (s = lr(t)), n) {
      const u = Ke(t, !0, i, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else a && (c.x = Hl(a));
  return {
    x: o.left + s.scrollLeft - c.x,
    y: o.top + s.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function as(e, t) {
  return !Ee(e) || xe(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Ul(e, t) {
  const r = me(e);
  if (!Ee(e))
    return r;
  let n = as(e, t);
  for (; n && Ah(n) && xe(n).position === "static"; )
    n = as(n, t);
  return n && (He(n) === "html" || He(n) === "body" && xe(n).position === "static" && !fo(n)) ? r : n || Th(e) || r;
}
const Bh = async function(e) {
  let {
    reference: t,
    floating: r,
    strategy: n
  } = e;
  const a = this.getOffsetParent || Ul, i = this.getDimensions;
  return {
    reference: Vh(t, await a(r), n),
    floating: {
      x: 0,
      y: 0,
      ...await i(r)
    }
  };
};
function Hh(e) {
  return xe(e).direction === "rtl";
}
const zh = {
  convertOffsetParentRelativeRectToViewportRelativeRect: jh,
  getDocumentElement: De,
  getClippingRect: Lh,
  getOffsetParent: Ul,
  getElementRects: Bh,
  getClientRects: Ih,
  getDimensions: kh,
  getScale: ft,
  isElement: Me,
  isRTL: Hh
};
function Uh(e, t) {
  let r = null, n;
  const a = De(e);
  function i() {
    clearTimeout(n), r && r.disconnect(), r = null;
  }
  function o(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const {
      left: u,
      top: d,
      width: l,
      height: h
    } = e.getBoundingClientRect();
    if (s || t(), !l || !h)
      return;
    const f = kt(d), g = kt(a.clientWidth - (u + l)), p = kt(a.clientHeight - (d + h)), m = kt(u), _ = {
      rootMargin: -f + "px " + -g + "px " + -p + "px " + -m + "px",
      threshold: ge(0, Ve(1, c)) || 1
    };
    let C = !0;
    function R(P) {
      const O = P[0].intersectionRatio;
      if (O !== c) {
        if (!C)
          return o();
        O ? o(!1, O) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      C = !1;
    }
    try {
      r = new IntersectionObserver(R, {
        ..._,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(R, _);
    }
    r.observe(e);
  }
  return o(!0), i;
}
function Wh(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, u = po(e), d = a || i ? [...u ? ar(u) : [], ...ar(t)] : [];
  d.forEach((b) => {
    a && b.addEventListener("scroll", r, {
      passive: !0
    }), i && b.addEventListener("resize", r);
  });
  const l = u && s ? Uh(u, r) : null;
  let h = -1, f = null;
  o && (f = new ResizeObserver((b) => {
    let [_] = b;
    _ && _.target === u && f && (f.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      f && f.observe(t);
    })), r();
  }), u && !c && f.observe(u), f.observe(t));
  let g, p = c ? Ke(e) : null;
  c && m();
  function m() {
    const b = Ke(e);
    p && (b.x !== p.x || b.y !== p.y || b.width !== p.width || b.height !== p.height) && r(), p = b, g = requestAnimationFrame(m);
  }
  return r(), () => {
    d.forEach((b) => {
      a && b.removeEventListener("scroll", r), i && b.removeEventListener("resize", r);
    }), l && l(), f && f.disconnect(), f = null, c && cancelAnimationFrame(g);
  };
}
const Gh = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), a = {
    platform: zh,
    ...r
  }, i = {
    ...a.platform,
    _c: n
  };
  return xh(e, t, {
    ...a,
    platform: i
  });
}, Kh = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: a
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? Qo({
        element: n.current,
        padding: a
      }).fn(r) : {} : n ? Qo({
        element: n,
        padding: a
      }).fn(r) : {};
    }
  };
};
var Kt = typeof document < "u" ? ao : ae;
function ir(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!ir(e[n], t[n]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), r = a.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const i = a[n];
      if (!(i === "_owner" && e.$$typeof) && !ir(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Wl(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function is(e, t) {
  const r = Wl(e);
  return Math.round(t * r) / r;
}
function os(e) {
  const t = D.useRef(e);
  return Kt(() => {
    t.current = e;
  }), t;
}
function Yh(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: u
  } = e, [d, l] = D.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, f] = D.useState(n);
  ir(h, n) || f(n);
  const [g, p] = D.useState(null), [m, b] = D.useState(null), _ = D.useCallback((q) => {
    q != O.current && (O.current = q, p(q));
  }, [p]), C = D.useCallback((q) => {
    q !== T.current && (T.current = q, b(q));
  }, [b]), R = i || g, P = o || m, O = D.useRef(null), T = D.useRef(null), x = D.useRef(d), w = os(c), E = os(a), S = D.useCallback(() => {
    if (!O.current || !T.current)
      return;
    const q = {
      placement: t,
      strategy: r,
      middleware: h
    };
    E.current && (q.platform = E.current), Gh(O.current, T.current, q).then((L) => {
      const k = {
        ...L,
        isPositioned: !0
      };
      I.current && !ir(x.current, k) && (x.current = k, pd.flushSync(() => {
        l(k);
      }));
    });
  }, [h, t, r, E]);
  Kt(() => {
    u === !1 && x.current.isPositioned && (x.current.isPositioned = !1, l((q) => ({
      ...q,
      isPositioned: !1
    })));
  }, [u]);
  const I = D.useRef(!1);
  Kt(() => (I.current = !0, () => {
    I.current = !1;
  }), []), Kt(() => {
    if (R && (O.current = R), P && (T.current = P), R && P) {
      if (w.current)
        return w.current(R, P, S);
      S();
    }
  }, [R, P, S, w]);
  const $ = D.useMemo(() => ({
    reference: O,
    floating: T,
    setReference: _,
    setFloating: C
  }), [_, C]), M = D.useMemo(() => ({
    reference: R,
    floating: P
  }), [R, P]), F = D.useMemo(() => {
    const q = {
      position: r,
      left: 0,
      top: 0
    };
    if (!M.floating)
      return q;
    const L = is(M.floating, d.x), k = is(M.floating, d.y);
    return s ? {
      ...q,
      transform: "translate(" + L + "px, " + k + "px)",
      ...Wl(M.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: L,
      top: k
    };
  }, [r, s, M.floating, d.x, d.y]);
  return D.useMemo(() => ({
    ...d,
    update: S,
    refs: $,
    elements: M,
    floatingStyles: F
  }), [d, S, $, M, F]);
}
function Xh(e) {
  const [t, r] = Z(void 0);
  return dt(() => {
    if (e) {
      r({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const n = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length) return;
        const i = a[0];
        let o, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          o = u.inlineSize, s = u.blockSize;
        } else
          o = e.offsetWidth, s = e.offsetHeight;
        r({
          width: o,
          height: s
        });
      });
      return n.observe(e, {
        box: "border-box"
      }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [
    e
  ]), t;
}
const Gl = "Popper", [Kl, Yl] = Ml(Gl), [Jh, Xl] = Kl(Gl), Zh = (e) => {
  const { __scopePopper: t, children: r } = e, [n, a] = Z(null);
  return /* @__PURE__ */ z(Jh, {
    scope: t,
    anchor: n,
    onAnchorChange: a
  }, r);
}, Qh = "PopperAnchor", ep = /* @__PURE__ */ be((e, t) => {
  const { __scopePopper: r, virtualRef: n, ...a } = e, i = Xl(Qh, r), o = ie(null), s = Ye(t, o);
  return ae(() => {
    i.onAnchorChange(n?.current || o.current);
  }), n ? null : /* @__PURE__ */ z(pt.div, er({}, a, {
    ref: s
  }));
}), Jl = "PopperContent", [tp, Py] = Kl(Jl), rp = /* @__PURE__ */ be((e, t) => {
  var r, n, a, i, o, s, c, u;
  const { __scopePopper: d, side: l = "bottom", sideOffset: h = 0, align: f = "center", alignOffset: g = 0, arrowPadding: p = 0, avoidCollisions: m = !0, collisionBoundary: b = [], collisionPadding: _ = 0, sticky: C = "partial", hideWhenDetached: R = !1, updatePositionStrategy: P = "optimized", onPlaced: O, ...T } = e, x = Xl(Jl, d), [w, E] = Z(null), S = Ye(
    t,
    (se) => E(se)
  ), [I, $] = Z(null), M = Xh(I), F = (r = M?.width) !== null && r !== void 0 ? r : 0, q = (n = M?.height) !== null && n !== void 0 ? n : 0, L = l + (f !== "center" ? "-" + f : ""), k = typeof _ == "number" ? _ : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ..._
  }, Q = Array.isArray(b) ? b : [
    b
  ], re = Q.length > 0, te = {
    padding: k,
    boundary: Q.filter(np),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: re
  }, { refs: he, floatingStyles: oe, placement: ue, isPositioned: pe, middlewareData: X } = Yh({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: L,
    whileElementsMounted: (...se) => Wh(...se, {
      animationFrame: P === "always"
    }),
    elements: {
      reference: x.anchor
    },
    middleware: [
      Sh({
        mainAxis: h + q,
        alignmentAxis: g
      }),
      m && Ph({
        mainAxis: !0,
        crossAxis: !1,
        limiter: C === "partial" ? Eh() : void 0,
        ...te
      }),
      m && wh({
        ...te
      }),
      Oh({
        ...te,
        apply: ({ elements: se, rects: Ne, availableWidth: Dt, availableHeight: Ft }) => {
          const { width: et, height: wr } = Ne.reference, tt = se.floating.style;
          tt.setProperty("--radix-popper-available-width", `${Dt}px`), tt.setProperty("--radix-popper-available-height", `${Ft}px`), tt.setProperty("--radix-popper-anchor-width", `${et}px`), tt.setProperty("--radix-popper-anchor-height", `${wr}px`);
        }
      }),
      I && Kh({
        element: I,
        padding: p
      }),
      ap({
        arrowWidth: F,
        arrowHeight: q
      }),
      R && Ch({
        strategy: "referenceHidden",
        ...te
      })
    ]
  }), [ve, le] = Zl(ue), ne = ke(O);
  dt(() => {
    pe && ne?.();
  }, [
    pe,
    ne
  ]);
  const ye = (a = X.arrow) === null || a === void 0 ? void 0 : a.x, Ae = (i = X.arrow) === null || i === void 0 ? void 0 : i.y, Fe = ((o = X.arrow) === null || o === void 0 ? void 0 : o.centerOffset) !== 0, [fe, Te] = Z();
  return dt(() => {
    w && Te(window.getComputedStyle(w).zIndex);
  }, [
    w
  ]), /* @__PURE__ */ z("div", {
    ref: he.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...oe,
      transform: pe ? oe.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: fe,
      "--radix-popper-transform-origin": [
        (s = X.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = X.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ z(tp, {
    scope: d,
    placedSide: ve,
    onArrowChange: $,
    arrowX: ye,
    arrowY: Ae,
    shouldHideArrow: Fe
  }, /* @__PURE__ */ z(pt.div, er({
    "data-side": ve,
    "data-align": le
  }, T, {
    ref: S,
    style: {
      ...T.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: pe ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (u = X.hide) !== null && u !== void 0 && u.referenceHidden ? 0 : void 0
    }
  }))));
});
function np(e) {
  return e !== null;
}
const ap = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var r, n, a, i, o;
    const { placement: s, rects: c, middlewareData: u } = t, l = ((r = u.arrow) === null || r === void 0 ? void 0 : r.centerOffset) !== 0, h = l ? 0 : e.arrowWidth, f = l ? 0 : e.arrowHeight, [g, p] = Zl(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[p], b = ((n = (a = u.arrow) === null || a === void 0 ? void 0 : a.x) !== null && n !== void 0 ? n : 0) + h / 2, _ = ((i = (o = u.arrow) === null || o === void 0 ? void 0 : o.y) !== null && i !== void 0 ? i : 0) + f / 2;
    let C = "", R = "";
    return g === "bottom" ? (C = l ? m : `${b}px`, R = `${-f}px`) : g === "top" ? (C = l ? m : `${b}px`, R = `${c.floating.height + f}px`) : g === "right" ? (C = `${-f}px`, R = l ? m : `${_}px`) : g === "left" && (C = `${c.floating.width + f}px`, R = l ? m : `${_}px`), {
      data: {
        x: C,
        y: R
      }
    };
  }
});
function Zl(e) {
  const [t, r = "center"] = e.split("-");
  return [
    t,
    r
  ];
}
const ip = Zh, op = ep, sp = rp;
function Zi() {
  return Zi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zi.apply(this, arguments);
}
const cp = /* @__PURE__ */ be((e, t) => {
  var r;
  const { container: n = globalThis == null || (r = globalThis.document) === null || r === void 0 ? void 0 : r.body, ...a } = e;
  return n ? /* @__PURE__ */ vd.createPortal(/* @__PURE__ */ z(pt.div, Zi({}, a, {
    ref: t
  })), n) : null;
});
function up(e, t) {
  return ud((r, n) => {
    const a = t[r][n];
    return a ?? r;
  }, e);
}
const vo = (e) => {
  const { present: t, children: r } = e, n = lp(t), a = typeof r == "function" ? r({
    present: n.isPresent
  }) : ut.only(r), i = Ye(n.ref, a.ref);
  return typeof r == "function" || n.isPresent ? /* @__PURE__ */ cr(a, {
    ref: i
  }) : null;
};
vo.displayName = "Presence";
function lp(e) {
  const [t, r] = Z(), n = ie({}), a = ie(e), i = ie("none"), o = e ? "mounted" : "unmounted", [s, c] = up(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ae(() => {
    const u = Vt(n.current);
    i.current = s === "mounted" ? u : "none";
  }, [
    s
  ]), dt(() => {
    const u = n.current, d = a.current;
    if (d !== e) {
      const h = i.current, f = Vt(u);
      e ? c("MOUNT") : f === "none" || u?.display === "none" ? c("UNMOUNT") : c(d && h !== f ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    c
  ]), dt(() => {
    if (t) {
      const u = (l) => {
        const f = Vt(n.current).includes(l.animationName);
        l.target === t && f && $l(
          () => c("ANIMATION_END")
        );
      }, d = (l) => {
        l.target === t && (i.current = Vt(n.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: G((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function Vt(e) {
  return e?.animationName || "none";
}
function fp({ prop: e, defaultProp: t, onChange: r = () => {
} }) {
  const [n, a] = dp({
    defaultProp: t,
    onChange: r
  }), i = e !== void 0, o = i ? e : n, s = ke(r), c = G((u) => {
    if (i) {
      const l = typeof u == "function" ? u(e) : u;
      l !== e && s(l);
    } else a(u);
  }, [
    i,
    e,
    a,
    s
  ]);
  return [
    o,
    c
  ];
}
function dp({ defaultProp: e, onChange: t }) {
  const r = Z(e), [n] = r, a = ie(n), i = ke(t);
  return ae(() => {
    a.current !== n && (i(n), a.current = n);
  }, [
    n,
    a,
    i
  ]), r;
}
var hp = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, at = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), Ht = {}, qr = 0, Ql = function(e) {
  return e && (e.host || Ql(e.parentNode));
}, pp = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = Ql(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, vp = function(e, t, r, n) {
  var a = pp(t, Array.isArray(e) ? e : [e]);
  Ht[r] || (Ht[r] = /* @__PURE__ */ new WeakMap());
  var i = Ht[r], o = [], s = /* @__PURE__ */ new Set(), c = new Set(a), u = function(l) {
    !l || s.has(l) || (s.add(l), u(l.parentNode));
  };
  a.forEach(u);
  var d = function(l) {
    !l || c.has(l) || Array.prototype.forEach.call(l.children, function(h) {
      if (s.has(h))
        d(h);
      else {
        var f = h.getAttribute(n), g = f !== null && f !== "false", p = (at.get(h) || 0) + 1, m = (i.get(h) || 0) + 1;
        at.set(h, p), i.set(h, m), o.push(h), p === 1 && g && Bt.set(h, !0), m === 1 && h.setAttribute(r, "true"), g || h.setAttribute(n, "true");
      }
    });
  };
  return d(t), s.clear(), qr++, function() {
    o.forEach(function(l) {
      var h = at.get(l) - 1, f = i.get(l) - 1;
      at.set(l, h), i.set(l, f), h || (Bt.has(l) || l.removeAttribute(n), Bt.delete(l)), f || l.removeAttribute(r);
    }), qr--, qr || (at = /* @__PURE__ */ new WeakMap(), at = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), Ht = {});
  };
}, gp = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = hp(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), vp(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, Pe = function() {
  return Pe = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Pe.apply(this, arguments);
};
function ef(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function mp(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Yt = "right-scroll-bar-position", Xt = "width-before-scroll-bar", bp = "with-scroll-bars-hidden", yp = "--removed-body-scroll-bar-size";
function _p(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function xp(e, t) {
  var r = Z(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
function wp(e, t) {
  return xp(null, function(r) {
    return e.forEach(function(n) {
      return _p(n, r);
    });
  });
}
function Cp(e) {
  return e;
}
function Rp(e, t) {
  t === void 0 && (t = Cp);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(i) {
      var o = t(i, n);
      return r.push(o), function() {
        r = r.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; r.length; ) {
        var o = r;
        r = [], o.forEach(i);
      }
      r = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var o = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(i), o = r;
      }
      var c = function() {
        var d = o;
        o = [], d.forEach(i);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), r = {
        push: function(d) {
          o.push(d), u();
        },
        filter: function(d) {
          return o = o.filter(d), r;
        }
      };
    }
  };
  return a;
}
function Sp(e) {
  e === void 0 && (e = {});
  var t = Rp(null);
  return t.options = Pe({ async: !0, ssr: !1 }, e), t;
}
var tf = function(e) {
  var t = e.sideCar, r = ef(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return D.createElement(n, Pe({}, r));
};
tf.isSideCarExport = !0;
function Pp(e, t) {
  return e.useMedium(t), tf;
}
var rf = Sp(), jr = function() {
}, fr = D.forwardRef(function(e, t) {
  var r = D.useRef(null), n = D.useState({
    onScrollCapture: jr,
    onWheelCapture: jr,
    onTouchMoveCapture: jr
  }), a = n[0], i = n[1], o = e.forwardProps, s = e.children, c = e.className, u = e.removeScrollBar, d = e.enabled, l = e.shards, h = e.sideCar, f = e.noIsolation, g = e.inert, p = e.allowPinchZoom, m = e.as, b = m === void 0 ? "div" : m, _ = ef(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), C = h, R = wp([r, t]), P = Pe(Pe({}, _), a);
  return D.createElement(
    D.Fragment,
    null,
    d && D.createElement(C, { sideCar: rf, removeScrollBar: u, shards: l, noIsolation: f, inert: g, setCallbacks: i, allowPinchZoom: !!p, lockRef: r }),
    o ? D.cloneElement(D.Children.only(s), Pe(Pe({}, P), { ref: R })) : D.createElement(b, Pe({}, P, { className: c, ref: R }), s)
  );
});
fr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
fr.classNames = {
  fullWidth: Xt,
  zeroRight: Yt
};
var Ep = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Op() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ep();
  return t && e.setAttribute("nonce", t), e;
}
function Ap(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Tp(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var $p = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = Op()) && (Ap(t, r), Tp(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, qp = function() {
  var e = $p();
  return function(t, r) {
    D.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, nf = function() {
  var e = qp(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, jp = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Ir = function(e) {
  return parseInt(e || "", 10) || 0;
}, Ip = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Ir(r), Ir(n), Ir(a)];
}, Mp = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return jp;
  var t = Ip(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, Dp = nf(), Fp = function(e, t, r, n) {
  var a = e.left, i = e.top, o = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(bp, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Yt, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Xt, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Yt, " .").concat(Yt, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Xt, " .").concat(Xt, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body {
    `).concat(yp, ": ").concat(s, `px;
  }
`);
}, Np = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n, i = D.useMemo(function() {
    return Mp(a);
  }, [a]);
  return D.createElement(Dp, { styles: Fp(i, !t, a, r ? "" : "!important") });
}, Qi = !1;
if (typeof window < "u")
  try {
    var zt = Object.defineProperty({}, "passive", {
      get: function() {
        return Qi = !0, !0;
      }
    });
    window.addEventListener("test", zt, zt), window.removeEventListener("test", zt, zt);
  } catch {
    Qi = !1;
  }
var it = Qi ? { passive: !1 } : !1, Lp = function(e) {
  return e.tagName === "TEXTAREA";
}, af = function(e, t) {
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !Lp(e) && r[t] === "visible")
  );
}, kp = function(e) {
  return af(e, "overflowY");
}, Vp = function(e) {
  return af(e, "overflowX");
}, ss = function(e, t) {
  var r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var n = of(e, r);
    if (n) {
      var a = sf(e, r), i = a[1], o = a[2];
      if (i > o)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== document.body);
  return !1;
}, Bp = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, Hp = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, of = function(e, t) {
  return e === "v" ? kp(t) : Vp(t);
}, sf = function(e, t) {
  return e === "v" ? Bp(t) : Hp(t);
}, zp = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Up = function(e, t, r, n, a) {
  var i = zp(e, window.getComputedStyle(t).direction), o = i * n, s = r.target, c = t.contains(s), u = !1, d = o > 0, l = 0, h = 0;
  do {
    var f = sf(e, s), g = f[0], p = f[1], m = f[2], b = p - m - i * g;
    (g || b) && of(e, s) && (l += b, h += g), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (d && l === 0 || !d && h === 0) && (u = !0), u;
}, Ut = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, cs = function(e) {
  return [e.deltaX, e.deltaY];
}, us = function(e) {
  return e && "current" in e ? e.current : e;
}, Wp = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Gp = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Kp = 0, ot = [];
function Yp(e) {
  var t = D.useRef([]), r = D.useRef([0, 0]), n = D.useRef(), a = D.useState(Kp++)[0], i = D.useState(function() {
    return nf();
  })[0], o = D.useRef(e);
  D.useEffect(function() {
    o.current = e;
  }, [e]), D.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = mp([e.lockRef.current], (e.shards || []).map(us), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = D.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2)
      return !o.current.allowPinchZoom;
    var b = Ut(p), _ = r.current, C = "deltaX" in p ? p.deltaX : _[0] - b[0], R = "deltaY" in p ? p.deltaY : _[1] - b[1], P, O = p.target, T = Math.abs(C) > Math.abs(R) ? "h" : "v";
    if ("touches" in p && T === "h" && O.type === "range")
      return !1;
    var x = ss(T, O);
    if (!x)
      return !0;
    if (x ? P = T : (P = T === "v" ? "h" : "v", x = ss(T, O)), !x)
      return !1;
    if (!n.current && "changedTouches" in p && (C || R) && (n.current = P), !P)
      return !0;
    var w = n.current || P;
    return Up(w, m, p, w === "h" ? C : R);
  }, []), c = D.useCallback(function(p) {
    var m = p;
    if (!(!ot.length || ot[ot.length - 1] !== i)) {
      var b = "deltaY" in m ? cs(m) : Ut(m), _ = t.current.filter(function(P) {
        return P.name === m.type && P.target === m.target && Wp(P.delta, b);
      })[0];
      if (_ && _.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!_) {
        var C = (o.current.shards || []).map(us).filter(Boolean).filter(function(P) {
          return P.contains(m.target);
        }), R = C.length > 0 ? s(m, C[0]) : !o.current.noIsolation;
        R && m.cancelable && m.preventDefault();
      }
    }
  }, []), u = D.useCallback(function(p, m, b, _) {
    var C = { name: p, delta: m, target: b, should: _ };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(R) {
        return R !== C;
      });
    }, 1);
  }, []), d = D.useCallback(function(p) {
    r.current = Ut(p), n.current = void 0;
  }, []), l = D.useCallback(function(p) {
    u(p.type, cs(p), p.target, s(p, e.lockRef.current));
  }, []), h = D.useCallback(function(p) {
    u(p.type, Ut(p), p.target, s(p, e.lockRef.current));
  }, []);
  D.useEffect(function() {
    return ot.push(i), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, it), document.addEventListener("touchmove", c, it), document.addEventListener("touchstart", d, it), function() {
      ot = ot.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", c, it), document.removeEventListener("touchmove", c, it), document.removeEventListener("touchstart", d, it);
    };
  }, []);
  var f = e.removeScrollBar, g = e.inert;
  return D.createElement(
    D.Fragment,
    null,
    g ? D.createElement(i, { styles: Gp(a) }) : null,
    f ? D.createElement(Np, { gapMode: "margin" }) : null
  );
}
const Xp = Pp(rf, Yp);
var cf = D.forwardRef(function(e, t) {
  return D.createElement(fr, Pe({}, e, { ref: t, sideCar: Xp }));
});
cf.classNames = fr.classNames;
const uf = "Popover", [lf, Ey] = Ml(uf, [
  Yl
]), go = Yl(), [Jp, mt] = lf(uf), Zp = (e) => {
  const { __scopePopover: t, children: r, open: n, defaultOpen: a, onOpenChange: i, modal: o = !1 } = e, s = go(t), c = ie(null), [u, d] = Z(!1), [l = !1, h] = fp({
    prop: n,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ z(ip, s, /* @__PURE__ */ z(Jp, {
    scope: t,
    contentId: dh(),
    triggerRef: c,
    open: l,
    onOpenChange: h,
    onOpenToggle: G(
      () => h(
        (f) => !f
      ),
      [
        h
      ]
    ),
    hasCustomAnchor: u,
    onCustomAnchorAdd: G(
      () => d(!0),
      []
    ),
    onCustomAnchorRemove: G(
      () => d(!1),
      []
    ),
    modal: o
  }, r));
}, Qp = "PopoverTrigger", ev = /* @__PURE__ */ be((e, t) => {
  const { __scopePopover: r, ...n } = e, a = mt(Qp, r), i = go(r), o = Ye(t, a.triggerRef), s = /* @__PURE__ */ z(pt.button, qe({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": a.open,
    "aria-controls": a.contentId,
    "data-state": hf(a.open)
  }, n, {
    ref: o,
    onClick: Ue(e.onClick, a.onOpenToggle)
  }));
  return a.hasCustomAnchor ? s : /* @__PURE__ */ z(op, qe({
    asChild: !0
  }, i), s);
}), ff = "PopoverPortal", [tv, rv] = lf(ff, {
  forceMount: void 0
}), nv = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: a } = e, i = mt(ff, t);
  return /* @__PURE__ */ z(tv, {
    scope: t,
    forceMount: r
  }, /* @__PURE__ */ z(vo, {
    present: r || i.open
  }, /* @__PURE__ */ z(cp, {
    asChild: !0,
    container: a
  }, n)));
}, Et = "PopoverContent", av = /* @__PURE__ */ be((e, t) => {
  const r = rv(Et, e.__scopePopover), { forceMount: n = r.forceMount, ...a } = e, i = mt(Et, e.__scopePopover);
  return /* @__PURE__ */ z(vo, {
    present: n || i.open
  }, i.modal ? /* @__PURE__ */ z(iv, qe({}, a, {
    ref: t
  })) : /* @__PURE__ */ z(ov, qe({}, a, {
    ref: t
  })));
}), iv = /* @__PURE__ */ be((e, t) => {
  const r = mt(Et, e.__scopePopover), n = ie(null), a = Ye(t, n), i = ie(!1);
  return ae(() => {
    const o = n.current;
    if (o) return gp(o);
  }, []), /* @__PURE__ */ z(cf, {
    as: so,
    allowPinchZoom: !0
  }, /* @__PURE__ */ z(df, qe({}, e, {
    ref: a,
    trapFocus: r.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Ue(e.onCloseAutoFocus, (o) => {
      var s;
      o.preventDefault(), i.current || (s = r.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: Ue(e.onPointerDownOutside, (o) => {
      const s = o.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, u = s.button === 2 || c;
      i.current = u;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: Ue(
      e.onFocusOutside,
      (o) => o.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), ov = /* @__PURE__ */ be((e, t) => {
  const r = mt(Et, e.__scopePopover), n = ie(!1), a = ie(!1);
  return /* @__PURE__ */ z(df, qe({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var o;
      if ((o = e.onCloseAutoFocus) === null || o === void 0 || o.call(e, i), !i.defaultPrevented) {
        var s;
        n.current || (s = r.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      n.current = !1, a.current = !1;
    },
    onInteractOutside: (i) => {
      var o, s;
      (o = e.onInteractOutside) === null || o === void 0 || o.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
      const c = i.target;
      ((s = r.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
    }
  }));
}), df = /* @__PURE__ */ be((e, t) => {
  const { __scopePopover: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: i, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: u, onInteractOutside: d, ...l } = e, h = mt(Et, r), f = go(r);
  return rh(), /* @__PURE__ */ z(nh, {
    asChild: !0,
    loop: !0,
    trapped: n,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ z(Qd, {
    asChild: !0,
    disableOutsidePointerEvents: o,
    onInteractOutside: d,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: u,
    onDismiss: () => h.onOpenChange(!1)
  }, /* @__PURE__ */ z(sp, qe({
    "data-state": hf(h.open),
    role: "dialog",
    id: h.contentId
  }, f, l, {
    ref: t,
    style: {
      ...l.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function hf(e) {
  return e ? "open" : "closed";
}
const pf = Zp, vf = ev, gf = nv, mf = av, sv = "_tooltip_5svgn_1", cv = "_popover_5svgn_5", ls = {
  tooltip: sv,
  popover: cv
}, Oy = ({
  actions: e,
  buttonProps: { onClick: t, ...r } = {},
  side: n = "bottom",
  align: a = "end"
}) => {
  const [i, o] = Z(!1), s = G(
    (u) => {
      u.stopPropagation(), t?.(u);
    },
    [t]
  );
  if (!e.length) return null;
  const c = (u, d) => {
    switch (u.type) {
      case "button":
      case "link": {
        const l = /* @__PURE__ */ y.jsx(
          Or.Item,
          {
            icon: u.icon,
            onClick: (h) => {
              u.onClick?.(h), o(!1);
            },
            isDisabled: u.disabled ?? !1,
            children: /* @__PURE__ */ y.jsxs(
              K,
              {
                as: "span",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2px",
                children: [
                  /* @__PURE__ */ y.jsx("span", { children: u.label }),
                  u.description && /* @__PURE__ */ y.jsx(W.Paragraph, { as: "span", variant: "4", subdued: !0, children: u.description })
                ]
              }
            )
          }
        );
        return /* @__PURE__ */ y.jsx(
          At,
          {
            className: ls.tooltip,
            content: u.tooltip,
            children: u.type === "link" ? cr(u.link, {
              children: l
            }) : l
          },
          d
        );
      }
      case "divider":
        return /* @__PURE__ */ y.jsx(Or.Divider, {}, d);
      default:
        return null;
    }
  };
  return /* @__PURE__ */ y.jsxs(pf, { open: i, onOpenChange: o, children: [
    /* @__PURE__ */ y.jsx(vf, { asChild: !0, children: /* @__PURE__ */ y.jsx(
      io,
      {
        variant: "tertiary",
        icon: "dots-v",
        onClick: s,
        ...r
      }
    ) }),
    /* @__PURE__ */ y.jsx(gf, { children: /* @__PURE__ */ y.jsx(
      mf,
      {
        className: ls.popover,
        side: n,
        align: a,
        sideOffset: 8,
        onOpenAutoFocus: (u) => u.preventDefault(),
        children: /* @__PURE__ */ y.jsx(Or, { children: e.map((u, d) => c(u, d)) })
      }
    ) })
  ] });
};
var _t = {}, eo = function() {
  return (eo = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }).apply(this, arguments);
}, uv = function() {
  function e(t, r, n) {
    var a = this;
    this.endVal = r, this.options = n, this.version = "2.6.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: !0, useGrouping: !0, useIndianSeparators: !1, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", enableScrollSpy: !1, scrollSpyDelay: 200, scrollSpyOnce: !1 }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(i) {
      a.startTime || (a.startTime = i);
      var o = i - a.startTime;
      a.remaining = a.duration - o, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(o, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(o, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (o / a.duration);
      var s = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
      a.frameVal = s ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), o < a.duration ? a.rAF = requestAnimationFrame(a.count) : a.finalEndVal !== null ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
    }, this.formatNumber = function(i) {
      var o, s, c, u, d = i < 0 ? "-" : "";
      o = Math.abs(i).toFixed(a.options.decimalPlaces);
      var l = (o += "").split(".");
      if (s = l[0], c = l.length > 1 ? a.options.decimal + l[1] : "", a.options.useGrouping) {
        u = "";
        for (var h = 3, f = 0, g = 0, p = s.length; g < p; ++g) a.options.useIndianSeparators && g === 4 && (h = 2, f = 1), g !== 0 && f % h == 0 && (u = a.options.separator + u), f++, u = s[p - g - 1] + u;
        s = u;
      }
      return a.options.numerals && a.options.numerals.length && (s = s.replace(/[0-9]/g, function(m) {
        return a.options.numerals[+m];
      }), c = c.replace(/[0-9]/g, function(m) {
        return a.options.numerals[+m];
      })), d + a.options.prefix + s + c + a.options.suffix;
    }, this.easeOutExpo = function(i, o, s, c) {
      return s * (1 - Math.pow(2, -10 * i / c)) * 1024 / 1023 + o;
    }, this.options = eo(eo({}, this.defaults), n), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(r), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof t == "string" ? document.getElementById(t) : t, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, t) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
      return a.handleScroll(a);
    }), window.onscroll = function() {
      window.onScrollFns.forEach(function(i) {
        return i();
      });
    }, this.handleScroll(this)));
  }
  return e.prototype.handleScroll = function(t) {
    if (t && window && !t.once) {
      var r = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), a = n.top + window.pageYOffset, i = n.top + n.height + window.pageYOffset;
      i < r && i > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
        return t.start();
      }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > i || a > r) && !t.paused && t.reset();
    }
  }, e.prototype.determineDirectionAndSmartEasing = function() {
    var t = this.finalEndVal ? this.finalEndVal : this.endVal;
    this.countDown = this.startVal > t;
    var r = t - this.startVal;
    if (Math.abs(r) > this.options.smartEasingThreshold && this.options.useEasing) {
      this.finalEndVal = t;
      var n = this.countDown ? 1 : -1;
      this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
    } else this.endVal = t, this.finalEndVal = null;
    this.finalEndVal !== null ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
  }, e.prototype.start = function(t) {
    this.error || (t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
  }, e.prototype.pauseResume = function() {
    this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
  }, e.prototype.reset = function() {
    cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
  }, e.prototype.update = function(t) {
    cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
  }, e.prototype.printValue = function(t) {
    var r;
    if (this.el) {
      var n = this.formattingFn(t);
      (r = this.options.plugin) !== null && r !== void 0 && r.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
    }
  }, e.prototype.ensureNumber = function(t) {
    return typeof t == "number" && !isNaN(t);
  }, e.prototype.validateValue = function(t) {
    var r = Number(t);
    return this.ensureNumber(r) ? r : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
  }, e.prototype.resetDuration = function() {
    this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
  }, e;
}();
const lv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CountUp: uv
}, Symbol.toStringTag, { value: "Module" })), fv = /* @__PURE__ */ Nd(lv);
var fs;
function dv() {
  if (fs) return _t;
  fs = 1, Object.defineProperty(_t, "__esModule", { value: !0 });
  var e = no, t = fv;
  function r(x, w) {
    var E = x == null ? null : typeof Symbol < "u" && x[Symbol.iterator] || x["@@iterator"];
    if (E != null) {
      var S, I, $, M, F = [], q = !0, L = !1;
      try {
        if ($ = (E = E.call(x)).next, w !== 0) for (; !(q = (S = $.call(E)).done) && (F.push(S.value), F.length !== w); q = !0) ;
      } catch (k) {
        L = !0, I = k;
      } finally {
        try {
          if (!q && E.return != null && (M = E.return(), Object(M) !== M)) return;
        } finally {
          if (L) throw I;
        }
      }
      return F;
    }
  }
  function n(x, w) {
    var E = Object.keys(x);
    if (Object.getOwnPropertySymbols) {
      var S = Object.getOwnPropertySymbols(x);
      w && (S = S.filter(function(I) {
        return Object.getOwnPropertyDescriptor(x, I).enumerable;
      })), E.push.apply(E, S);
    }
    return E;
  }
  function a(x) {
    for (var w = 1; w < arguments.length; w++) {
      var E = arguments[w] != null ? arguments[w] : {};
      w % 2 ? n(Object(E), !0).forEach(function(S) {
        i(x, S, E[S]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(E)) : n(Object(E)).forEach(function(S) {
        Object.defineProperty(x, S, Object.getOwnPropertyDescriptor(E, S));
      });
    }
    return x;
  }
  function i(x, w, E) {
    return w = p(w), w in x ? Object.defineProperty(x, w, {
      value: E,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : x[w] = E, x;
  }
  function o() {
    return o = Object.assign ? Object.assign.bind() : function(x) {
      for (var w = 1; w < arguments.length; w++) {
        var E = arguments[w];
        for (var S in E)
          Object.prototype.hasOwnProperty.call(E, S) && (x[S] = E[S]);
      }
      return x;
    }, o.apply(this, arguments);
  }
  function s(x, w) {
    if (x == null) return {};
    var E = {}, S = Object.keys(x), I, $;
    for ($ = 0; $ < S.length; $++)
      I = S[$], !(w.indexOf(I) >= 0) && (E[I] = x[I]);
    return E;
  }
  function c(x, w) {
    if (x == null) return {};
    var E = s(x, w), S, I;
    if (Object.getOwnPropertySymbols) {
      var $ = Object.getOwnPropertySymbols(x);
      for (I = 0; I < $.length; I++)
        S = $[I], !(w.indexOf(S) >= 0) && Object.prototype.propertyIsEnumerable.call(x, S) && (E[S] = x[S]);
    }
    return E;
  }
  function u(x, w) {
    return d(x) || r(x, w) || l(x, w) || f();
  }
  function d(x) {
    if (Array.isArray(x)) return x;
  }
  function l(x, w) {
    if (x) {
      if (typeof x == "string") return h(x, w);
      var E = Object.prototype.toString.call(x).slice(8, -1);
      if (E === "Object" && x.constructor && (E = x.constructor.name), E === "Map" || E === "Set") return Array.from(x);
      if (E === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(E)) return h(x, w);
    }
  }
  function h(x, w) {
    (w == null || w > x.length) && (w = x.length);
    for (var E = 0, S = new Array(w); E < w; E++) S[E] = x[E];
    return S;
  }
  function f() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function g(x, w) {
    if (typeof x != "object" || x === null) return x;
    var E = x[Symbol.toPrimitive];
    if (E !== void 0) {
      var S = E.call(x, w);
      if (typeof S != "object") return S;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (w === "string" ? String : Number)(x);
  }
  function p(x) {
    var w = g(x, "string");
    return typeof w == "symbol" ? w : String(w);
  }
  var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? e.useLayoutEffect : e.useEffect;
  function b(x) {
    var w = e.useRef(x);
    return m(function() {
      w.current = x;
    }), e.useCallback(function() {
      for (var E = arguments.length, S = new Array(E), I = 0; I < E; I++)
        S[I] = arguments[I];
      return w.current.apply(void 0, S);
    }, []);
  }
  var _ = function(w, E) {
    var S = E.decimal, I = E.decimals, $ = E.duration, M = E.easingFn, F = E.end, q = E.formattingFn, L = E.numerals, k = E.prefix, Q = E.separator, re = E.start, te = E.suffix, he = E.useEasing, oe = E.useGrouping, ue = E.useIndianSeparators, pe = E.enableScrollSpy, X = E.scrollSpyDelay, ve = E.scrollSpyOnce;
    return new t.CountUp(w, F, {
      startVal: re,
      duration: $,
      decimal: S,
      decimalPlaces: I,
      easingFn: M,
      formattingFn: q,
      numerals: L,
      separator: Q,
      prefix: k,
      suffix: te,
      useEasing: he,
      useIndianSeparators: ue,
      useGrouping: oe,
      enableScrollSpy: pe,
      scrollSpyDelay: X,
      scrollSpyOnce: ve
    });
  }, C = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"], R = {
    decimal: ".",
    separator: ",",
    delay: null,
    prefix: "",
    suffix: "",
    duration: 2,
    start: 0,
    decimals: 0,
    startOnMount: !0,
    enableReinitialize: !0,
    useEasing: !0,
    useGrouping: !0,
    useIndianSeparators: !1
  }, P = function(w) {
    var E = Object.fromEntries(Object.entries(w).filter(function(fe) {
      var Te = u(fe, 2), se = Te[1];
      return se !== void 0;
    })), S = e.useMemo(function() {
      return a(a({}, R), E);
    }, [w]), I = S.ref, $ = S.startOnMount, M = S.enableReinitialize, F = S.delay, q = S.onEnd, L = S.onStart, k = S.onPauseResume, Q = S.onReset, re = S.onUpdate, te = c(S, C), he = e.useRef(), oe = e.useRef(), ue = e.useRef(!1), pe = b(function() {
      return _(typeof I == "string" ? I : I.current, te);
    }), X = b(function(fe) {
      var Te = he.current;
      if (Te && !fe)
        return Te;
      var se = pe();
      return he.current = se, se;
    }), ve = b(function() {
      var fe = function() {
        return X(!0).start(function() {
          q?.({
            pauseResume: le,
            reset: ne,
            start: Ae,
            update: ye
          });
        });
      };
      F && F > 0 ? oe.current = setTimeout(fe, F * 1e3) : fe(), L?.({
        pauseResume: le,
        reset: ne,
        update: ye
      });
    }), le = b(function() {
      X().pauseResume(), k?.({
        reset: ne,
        start: Ae,
        update: ye
      });
    }), ne = b(function() {
      X().el && (oe.current && clearTimeout(oe.current), X().reset(), Q?.({
        pauseResume: le,
        start: Ae,
        update: ye
      }));
    }), ye = b(function(fe) {
      X().update(fe), re?.({
        pauseResume: le,
        reset: ne,
        start: Ae
      });
    }), Ae = b(function() {
      ne(), ve();
    }), Fe = b(function(fe) {
      $ && (fe && ne(), ve());
    });
    return e.useEffect(function() {
      ue.current ? M && Fe(!0) : (ue.current = !0, Fe());
    }, [M, ue, Fe, F, w.start, w.suffix, w.prefix, w.duration, w.separator, w.decimals, w.decimal, w.formattingFn]), e.useEffect(function() {
      return function() {
        ne();
      };
    }, [ne]), {
      start: Ae,
      pauseResume: le,
      reset: ne,
      update: ye,
      getCountUp: X
    };
  }, O = ["className", "redraw", "containerProps", "children", "style"], T = function(w) {
    var E = w.className, S = w.redraw, I = w.containerProps, $ = w.children, M = w.style, F = c(w, O), q = e.useRef(null), L = e.useRef(!1), k = P(a(a({}, F), {}, {
      ref: q,
      startOnMount: typeof $ != "function" || w.delay === 0,
      // component manually restarts
      enableReinitialize: !1
    })), Q = k.start, re = k.reset, te = k.update, he = k.pauseResume, oe = k.getCountUp, ue = b(function() {
      Q();
    }), pe = b(function(le) {
      w.preserveValue || re(), te(le);
    }), X = b(function() {
      if (typeof w.children == "function" && !(q.current instanceof Element)) {
        console.error(`Couldn't find attached element to hook the CountUp instance into! Try to attach "containerRef" from the render prop to a an Element, eg. <span ref={containerRef} />.`);
        return;
      }
      oe();
    });
    e.useEffect(function() {
      X();
    }, [X]), e.useEffect(function() {
      L.current && pe(w.end);
    }, [w.end, pe]);
    var ve = S && w;
    return e.useEffect(function() {
      S && L.current && ue();
    }, [ue, S, ve]), e.useEffect(function() {
      !S && L.current && ue();
    }, [ue, S, w.start, w.suffix, w.prefix, w.duration, w.separator, w.decimals, w.decimal, w.className, w.formattingFn]), e.useEffect(function() {
      L.current = !0;
    }, []), typeof $ == "function" ? $({
      countUpRef: q,
      start: Q,
      reset: re,
      update: te,
      pauseResume: he,
      getCountUp: oe
    }) : /* @__PURE__ */ e.createElement("span", o({
      className: E,
      ref: q,
      style: M
    }, I), typeof w.start < "u" ? oe().formattingFn(w.start) : "");
  };
  return _t.default = T, _t.useCountUp = P, _t;
}
var hv = dv();
const pv = /* @__PURE__ */ Re(hv), vv = "_bar_1n5dj_1", gv = "_section_1n5dj_5", mv = "_sectionHidden_1n5dj_8", bv = "_sectionInheritRadius_1n5dj_11", yv = "_valueOutside_1n5dj_15", st = {
  bar: vv,
  section: gv,
  sectionHidden: mv,
  sectionInheritRadius: bv,
  valueOutside: yv
}, Jt = ({
  value: e,
  label: t,
  labelWidth: r,
  theme: n = ["var(--dixa-color-purple-700)", "var(--dixa-color-neutral-200)"],
  showFullBar: a = !1,
  showDifference: i = !1
}) => {
  const o = Math.min(e, 100), [s, c] = Z([
    null,
    null
  ]), u = ql(s);
  ae(() => {
    c([
      o,
      ...a ? [100 - o] : []
    ]);
  }, [o, a]);
  const d = 1.5, l = Y(
    () => s.map((h, f) => {
      const g = o && f === 0 || i, p = h !== null && h < 20, m = $e(st.section, {
        [st.sectionHidden]: a && h === 0,
        [st.sectionInheritRadius]: !a
      }), b = $e(st.section, {
        [st.valueOutside]: p
      });
      return /* @__PURE__ */ y.jsx(
        K,
        {
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "0 100",
          background: n[f],
          color: "neutral.000",
          className: m,
          style: {
            flexBasis: `${h ?? 0}%`,
            transition: `flex-basis ${d}s ease-out`
          },
          children: g && /* @__PURE__ */ y.jsx(
            W.Paragraph,
            {
              className: b,
              variant: "4",
              color: f === 0 && !p ? "var(--dixa-color-neutral-000)" : "var(--dixa-color-neutral-900)",
              children: /* @__PURE__ */ y.jsx(
                pv,
                {
                  start: u?.[f] ?? 0,
                  end: h ?? 0,
                  duration: d,
                  delay: 0,
                  suffix: "%",
                  children: ({ countUpRef: _ }) => /* @__PURE__ */ y.jsx("span", { ref: _ })
                }
              )
            }
          )
        },
        f
      );
    }),
    [
      o,
      n,
      i,
      a,
      s,
      u
    ]
  );
  return /* @__PURE__ */ y.jsxs(K, { alignItems: "center", gap: "200", children: [
    t && /* @__PURE__ */ y.jsx(oo, { minWidth: r ? `${r}px` : "auto", children: /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", children: t }) }),
    /* @__PURE__ */ y.jsx(K, { flex: "1", className: st.bar, height: "20px", borderRadius: "50", children: l })
  ] });
};
function We(e, t = { compact: !1 }) {
  if (e < 1e3)
    return `${(e / 1e3).toFixed(0)}s`;
  const r = Math.floor(e / 1e3 % 60), n = Math.floor(e / (1e3 * 60) % 60), a = Math.floor(e / (1e3 * 60 * 60) % 24), i = Math.floor(e / (1e3 * 60 * 60 * 24)), o = (c, u) => c > 0 ? `${c}${u}` : "";
  return [
    o(i, "d"),
    o(a, "h"),
    o(n, "m") || (t.compact ? "" : "0m"),
    o(r, "s") || (t.compact ? "" : "0s")
  ].filter(Boolean).join(" ");
}
function or(e) {
  return /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})?)?$/.test(e) ? lt(e, lt.ISO_8601, !0).isValid() : !1;
}
const ds = 1e6, hs = 1e3;
function bf(e) {
  if (e < hs) return `${e}`;
  const t = e >= ds;
  return `${parseFloat(
    (e / (t ? ds : hs)).toFixed(1)
  )}${t ? "M" : "K"}`;
}
function Ot(e) {
  return e.toLocaleString(navigator.language);
}
const Ay = (e) => ({
  metrics: e.filter(_v),
  chart: e.find(xv),
  heatmap: e.find(wv),
  table: e.find(Cv),
  presence: e.find(Rv),
  insight: e.find(Sv)
}), _v = (e) => e.type === "metric", xv = (e) => e.type === "chart" && e.visualization !== "heatmap", wv = (e) => e.type === "chart" && e.visualization === "heatmap", Cv = (e) => e.type === "table", Rv = (e) => e.type === "presence", Sv = (e) => e.type === "ai_insight", qt = (e, t) => {
  switch (t) {
    case "duration":
      return We(e).split(" ").slice(0, 2).join(" ");
    case "count":
      return bf(e);
    case "number":
      return Ot(e);
    case "percentage":
      return `${Ot(e)}%`;
    case "timer":
      return We(e);
    default:
      return "";
  }
}, sr = {
  default: 8,
  rating: 5
}, to = jl.purple[700], Pv = (e) => /^#|^rgb(a)?\(|^hsl(a)?\(|^var\(/.test(e), Ev = (e) => {
  const [t, r] = e.split("-"), n = Number(r);
  return sr[t] ? n >= 1 && n <= sr[t] : !1;
}, yf = (e) => Pv(e) ? e : Ev(e) ? `var(--dixa-analytics-color-${e}, ${to})` : to, ct = (e, t = "default", r) => {
  if (r)
    return yf(r);
  const n = sr[t] ?? sr.default, a = e % n + 1;
  return `var(--dixa-analytics-color-${t}-${a}, ${to})`;
}, Ov = "_container_1t2a7_1", Av = {
  container: Ov
}, Tv = we(
  function({
    granularities: t,
    onChangeGranularity: r
  }) {
    return /* @__PURE__ */ y.jsx(Ol, { variant: "secondary", children: t.map(({ value: n, selected: a }) => /* @__PURE__ */ y.jsx(
      Al,
      {
        onClick: a ? void 0 : () => r?.(n),
        active: a,
        children: n
      },
      n
    )) });
  }
), $v = "_root_6kwn9_1", qv = "_rootBounded_6kwn9_7", jv = "_rootFluid_6kwn9_7", Mr = {
  root: $v,
  rootBounded: qv,
  rootFluid: jv
}, ro = ({
  bounded: e = !1,
  fluid: t = !1,
  children: r
}) => {
  const n = $e(Mr.root, {
    [Mr.rootBounded]: e,
    [Mr.rootFluid]: t
  });
  return /* @__PURE__ */ y.jsx("div", { className: n, children: r });
}, Iv = we(
  function({
    data: t
  }) {
    const [r, n] = Z(0);
    return ae(() => {
      n(Date.now() - t);
    }, [t]), gd(() => {
      n(Date.now() - t);
    }, 1e3), /* @__PURE__ */ y.jsx(y.Fragment, { children: qt(r, "timer") });
  }
), Mv = "_wrapper_1w7q6_1", Dv = "_text_1w7q6_6", ps = {
  wrapper: Mv,
  text: Dv
}, Fv = we(function({
  className: t,
  data: r,
  format: n,
  color: a,
  suffix: i
}) {
  const o = Y(() => {
    if (r === null) return "n.a.";
    switch (n) {
      case "timer":
        return /* @__PURE__ */ y.jsx(Iv, { data: r });
      default:
        return qt(r, n);
    }
  }, [r, n]), s = Y(() => {
    if (r !== null)
      switch (n) {
        case "duration":
          return We(r);
        case "count":
          return Ot(r);
        default:
          return;
      }
  }, [r, n]), u = !(r !== null && s !== o) || ["number", "percentage", "timer"].includes(n);
  return /* @__PURE__ */ y.jsx(
    At,
    {
      content: s,
      disabled: u,
      wrap: "div",
      wrapProps: { className: ps.wrapper },
      children: /* @__PURE__ */ y.jsxs(
        W.Heading,
        {
          variant: "heading-1",
          color: a ?? (r === null ? "tertiary" : void 0),
          className: $e(ps.text, t),
          as: "span",
          children: [
            o,
            i
          ]
        }
      )
    }
  );
}), Nv = "_colorIndicator_luubh_1", Lv = {
  colorIndicator: Nv
}, _f = we(function({
  instrument: t,
  theme: r = "light"
}) {
  const { data: n, format: a, title: i, description: o, color: s } = t, c = s ? yf(s) : void 0, u = r === "dark" ? "inherit" : void 0;
  return /* @__PURE__ */ y.jsxs(K, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ y.jsxs(K, { alignItems: "center", gap: "100", title: i, children: [
      s && /* @__PURE__ */ y.jsx(
        oo,
        {
          as: "span",
          className: Lv.colorIndicator,
          background: c
        }
      ),
      /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", color: u, subdued: !0, children: i })
    ] }),
    /* @__PURE__ */ y.jsx(Fv, { data: n, format: a, color: u }),
    o && /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", color: u, subdued: !0, children: o })
  ] });
}), kv = {
  fontFamily: "var(--dixa-typography-family-default)",
  fontSize: "var(--dixa-typography-size-200)",
  fill: "var(--dixa-typography-color-tertiary)"
}, Vv = {
  bar: "chart-bar",
  line: "chart-line",
  area: "chart-area",
  pie: "chart-pie",
  donut: "chart-donut"
}, Ge = {
  tickCount: 5,
  tickProps: kv,
  visualizationIcons: Vv
}, Bv = ({ categories: e, series: t }, { omitZero: r }) => e.map((n, a) => {
  const i = t.reduce(
    (o, { label: s, data: c }) => {
      const { value: u } = dr(c[a]);
      return (r ? !u : u === null) ? o : { ...o, [s]: u };
    },
    {}
  );
  return {
    name: n.label,
    ...i
  };
}), dr = (e) => e === null || typeof e == "number" ? { value: e } : {
  value: e?.value ?? null,
  metrics: e?.metrics
};
var Dr, vs;
function xf() {
  if (vs) return Dr;
  vs = 1;
  var e = typeof Nt == "object" && Nt && Nt.Object === Object && Nt;
  return Dr = e, Dr;
}
var Fr, gs;
function Oe() {
  if (gs) return Fr;
  gs = 1;
  var e = xf(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return Fr = r, Fr;
}
var Nr, ms;
function jt() {
  if (ms) return Nr;
  ms = 1;
  var e = Oe(), t = e.Symbol;
  return Nr = t, Nr;
}
var Lr, bs;
function wf() {
  if (bs) return Lr;
  bs = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = Array(a); ++n < a; )
      i[n] = r(t[n], n, t);
    return i;
  }
  return Lr = e, Lr;
}
var kr, ys;
function Se() {
  if (ys) return kr;
  ys = 1;
  var e = Array.isArray;
  return kr = e, kr;
}
var Vr, _s;
function Hv() {
  if (_s) return Vr;
  _s = 1;
  var e = jt(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function i(o) {
    var s = r.call(o, a), c = o[a];
    try {
      o[a] = void 0;
      var u = !0;
    } catch {
    }
    var d = n.call(o);
    return u && (s ? o[a] = c : delete o[a]), d;
  }
  return Vr = i, Vr;
}
var Br, xs;
function zv() {
  if (xs) return Br;
  xs = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return Br = r, Br;
}
var Hr, ws;
function Xe() {
  if (ws) return Hr;
  ws = 1;
  var e = jt(), t = Hv(), r = zv(), n = "[object Null]", a = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function o(s) {
    return s == null ? s === void 0 ? a : n : i && i in Object(s) ? t(s) : r(s);
  }
  return Hr = o, Hr;
}
var zr, Cs;
function Je() {
  if (Cs) return zr;
  Cs = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return zr = e, zr;
}
var Ur, Rs;
function It() {
  if (Rs) return Ur;
  Rs = 1;
  var e = Xe(), t = Je(), r = "[object Symbol]";
  function n(a) {
    return typeof a == "symbol" || t(a) && e(a) == r;
  }
  return Ur = n, Ur;
}
var Wr, Ss;
function Cf() {
  if (Ss) return Wr;
  Ss = 1;
  var e = jt(), t = wf(), r = Se(), n = It(), a = e ? e.prototype : void 0, i = a ? a.toString : void 0;
  function o(s) {
    if (typeof s == "string")
      return s;
    if (r(s))
      return t(s, o) + "";
    if (n(s))
      return i ? i.call(s) : "";
    var c = s + "";
    return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
  }
  return Wr = o, Wr;
}
var Gr, Ps;
function Uv() {
  if (Ps) return Gr;
  Ps = 1;
  function e(t, r, n) {
    var a = -1, i = t.length;
    r < 0 && (r = -r > i ? 0 : i + r), n = n > i ? i : n, n < 0 && (n += i), i = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var o = Array(i); ++a < i; )
      o[a] = t[a + r];
    return o;
  }
  return Gr = e, Gr;
}
var Kr, Es;
function Rf() {
  if (Es) return Kr;
  Es = 1;
  var e = Uv();
  function t(r, n, a) {
    var i = r.length;
    return a = a === void 0 ? i : a, !n && a >= i ? r : e(r, n, a);
  }
  return Kr = t, Kr;
}
var Yr, Os;
function hr() {
  if (Os) return Yr;
  Os = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "\\u200d", s = RegExp("[" + o + e + a + i + "]");
  function c(u) {
    return s.test(u);
  }
  return Yr = c, Yr;
}
var Xr, As;
function Ze() {
  if (As) return Xr;
  As = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return Xr = e, Xr;
}
var Jr, Ts;
function Wv() {
  if (Ts) return Jr;
  Ts = 1;
  var e = Xe(), t = Je(), r = "[object RegExp]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Jr = n, Jr;
}
var Zr, $s;
function mo() {
  if ($s) return Zr;
  $s = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return Zr = e, Zr;
}
var Rt = { exports: {} };
Rt.exports;
var qs;
function Sf() {
  return qs || (qs = 1, function(e, t) {
    var r = xf(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = function() {
      try {
        var c = a && a.require && a.require("util").types;
        return c || o && o.binding && o.binding("util");
      } catch {
      }
    }();
    e.exports = s;
  }(Rt, Rt.exports)), Rt.exports;
}
var Qr, js;
function Gv() {
  if (js) return Qr;
  js = 1;
  var e = Wv(), t = mo(), r = Sf(), n = r && r.isRegExp, a = n ? t(n) : e;
  return Qr = a, Qr;
}
var en, Is;
function Pf() {
  if (Is) return en;
  Is = 1;
  function e(t) {
    return function(r) {
      return r?.[t];
    };
  }
  return en = e, en;
}
var tn, Ms;
function Kv() {
  if (Ms) return tn;
  Ms = 1;
  var e = Pf(), t = e("length");
  return tn = t, tn;
}
var rn, Ds;
function Yv() {
  if (Ds) return rn;
  Ds = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + a + "]", c = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + c + ")", d = "[^" + e + "]", l = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", f = "\\u200d", g = u + "?", p = "[" + i + "]?", m = "(?:" + f + "(?:" + [d, l, h].join("|") + ")" + p + g + ")*", b = p + g + m, _ = "(?:" + [d + s + "?", s, l, h, o].join("|") + ")", C = RegExp(c + "(?=" + c + ")|" + _ + b, "g");
  function R(P) {
    for (var O = C.lastIndex = 0; C.test(P); )
      ++O;
    return O;
  }
  return rn = R, rn;
}
var nn, Fs;
function Xv() {
  if (Fs) return nn;
  Fs = 1;
  var e = Kv(), t = hr(), r = Yv();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return nn = n, nn;
}
var an, Ns;
function Jv() {
  if (Ns) return an;
  Ns = 1;
  function e(t) {
    return t.split("");
  }
  return an = e, an;
}
var on, Ls;
function Zv() {
  if (Ls) return on;
  Ls = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + a + "]", c = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + c + ")", d = "[^" + e + "]", l = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", f = "\\u200d", g = u + "?", p = "[" + i + "]?", m = "(?:" + f + "(?:" + [d, l, h].join("|") + ")" + p + g + ")*", b = p + g + m, _ = "(?:" + [d + s + "?", s, l, h, o].join("|") + ")", C = RegExp(c + "(?=" + c + ")|" + _ + b, "g");
  function R(P) {
    return P.match(C) || [];
  }
  return on = R, on;
}
var sn, ks;
function Ef() {
  if (ks) return sn;
  ks = 1;
  var e = Jv(), t = hr(), r = Zv();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return sn = n, sn;
}
var cn, Vs;
function Qv() {
  if (Vs) return cn;
  Vs = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return cn = t, cn;
}
var un, Bs;
function eg() {
  if (Bs) return un;
  Bs = 1;
  var e = Qv(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return un = r, un;
}
var ln, Hs;
function Of() {
  if (Hs) return ln;
  Hs = 1;
  var e = eg(), t = Ze(), r = It(), n = NaN, a = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt;
  function c(u) {
    if (typeof u == "number")
      return u;
    if (r(u))
      return n;
    if (t(u)) {
      var d = typeof u.valueOf == "function" ? u.valueOf() : u;
      u = t(d) ? d + "" : d;
    }
    if (typeof u != "string")
      return u === 0 ? u : +u;
    u = e(u);
    var l = i.test(u);
    return l || o.test(u) ? s(u.slice(2), l ? 2 : 8) : a.test(u) ? n : +u;
  }
  return ln = c, ln;
}
var fn, zs;
function tg() {
  if (zs) return fn;
  zs = 1;
  var e = Of(), t = 1 / 0, r = 17976931348623157e292;
  function n(a) {
    if (!a)
      return a === 0 ? a : 0;
    if (a = e(a), a === t || a === -t) {
      var i = a < 0 ? -1 : 1;
      return i * r;
    }
    return a === a ? a : 0;
  }
  return fn = n, fn;
}
var dn, Us;
function rg() {
  if (Us) return dn;
  Us = 1;
  var e = tg();
  function t(r) {
    var n = e(r), a = n % 1;
    return n === n ? a ? n - a : n : 0;
  }
  return dn = t, dn;
}
var hn, Ws;
function pr() {
  if (Ws) return hn;
  Ws = 1;
  var e = Cf();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return hn = t, hn;
}
var pn, Gs;
function ng() {
  if (Gs) return pn;
  Gs = 1;
  var e = Cf(), t = Rf(), r = hr(), n = Ze(), a = Gv(), i = Xv(), o = Ef(), s = rg(), c = pr(), u = 30, d = "...", l = /\w*$/;
  function h(f, g) {
    var p = u, m = d;
    if (n(g)) {
      var b = "separator" in g ? g.separator : b;
      p = "length" in g ? s(g.length) : p, m = "omission" in g ? e(g.omission) : m;
    }
    f = c(f);
    var _ = f.length;
    if (r(f)) {
      var C = o(f);
      _ = C.length;
    }
    if (p >= _)
      return f;
    var R = p - i(m);
    if (R < 1)
      return m;
    var P = C ? t(C, 0, R).join("") : f.slice(0, R);
    if (b === void 0)
      return P + m;
    if (C && (R += P.length - R), a(b)) {
      if (f.slice(R).search(b)) {
        var O, T = P;
        for (b.global || (b = RegExp(b.source, c(l.exec(b)) + "g")), b.lastIndex = 0; O = b.exec(T); )
          var x = O.index;
        P = P.slice(0, x === void 0 ? R : x);
      }
    } else if (f.indexOf(e(b), R) != R) {
      var w = P.lastIndexOf(b);
      w > -1 && (P = P.slice(0, w));
    }
    return P + m;
  }
  return pn = h, pn;
}
var ag = ng();
const ig = /* @__PURE__ */ Re(ag), Af = (e, t = "D", {
  long: r = !1,
  timezone: n = lt.tz.guess()
} = {}) => {
  const a = lt.tz(e, n), i = lt.locale() === "en", o = (s) => r ? s.format("ddd, ll") : s.format(i ? "MMM DD" : "DD MMM");
  switch (t) {
    case "H":
      return a.format("LT");
    case "W":
      return r ? `${o(a)} - ${o(
        a.endOf("week")
      )} (W${a.format("W")})` : o(a);
    case "M":
      return a.format(r ? "MMM YYYY" : "MMM");
    case "D":
    default:
      return o(a);
  }
}, Tf = (e, t = {}) => t?.length ? ig(e, t) : e, og = "_root_7a8ds_48", sg = {
  root: og
}, cg = we(function({
  instrument: t,
  granularity: r,
  timezone: n,
  tooltipProps: a
}) {
  const { active: i, payload: o, label: s } = a, { categories: c, series: u } = t.data, d = c.find((_) => _.label === s), l = d?.metrics ?? [], h = 6 * 4, f = Math.max(0, (o?.length ?? 0) - h), g = Y(() => u.length === 1 && ["count", "number"].includes(u[0].options?.format ?? "number") && !c.every(({ label: C }) => or(C)) ? u[0].data.reduce((C, R) => {
    const { value: P } = dr(R);
    return typeof P == "number" ? C + P : C;
  }, 0) : null, [c, u]), p = Y(
    () => o?.slice(
      0,
      // When there are more series than the limit, subtract one to make room for the overflow indicator.
      f > 0 ? h - 1 : h
    ).map((_, C) => {
      const R = _.value ?? 0, P = R && g ? R / g * 100 : null, O = P ? `${P.toFixed(2)}%` : void 0;
      return {
        type: "metric",
        title: _.name ?? "",
        color: _.color,
        data: R,
        format: u[C].options?.format ?? "number",
        description: O
      };
    }),
    [o, u, h, f, g]
  ), m = G(
    (_) => _?.map((C) => /* @__PURE__ */ y.jsx(
      _f,
      {
        instrument: C,
        theme: "dark"
      },
      C.title
    )),
    []
  ), b = Y(
    () => d?.label ? or(d.label) ? Af(d.label, r, {
      timezone: n,
      long: !0
    }) : Tf(d.label) : null,
    [d?.label, r, n]
  );
  return !i || !o ? null : /* @__PURE__ */ y.jsxs("div", { className: sg.root, children: [
    b && /* @__PURE__ */ y.jsxs(K, { flexDirection: "column", gap: "100", children: [
      /* @__PURE__ */ y.jsx(W.Heading, { variant: "heading-2", color: "inherit", children: b }),
      d?.description && /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", color: "inherit", children: d.description })
    ] }),
    l.length > 0 && /* @__PURE__ */ y.jsx(ro, { bounded: !0, children: m(l) }),
    /* @__PURE__ */ y.jsxs(ro, { bounded: !0, children: [
      m(p),
      f > 0 && /* @__PURE__ */ y.jsx(K, { flex: "1", alignItems: "center", children: /* @__PURE__ */ y.jsxs(W.Heading, { variant: "heading-2", color: "inherit", children: [
        "+ ",
        f + 1,
        " more"
      ] }) })
    ] })
  ] });
});
var vn, Ks;
function ug() {
  if (Ks) return vn;
  Ks = 1;
  var e = Rf(), t = hr(), r = Ef(), n = pr();
  function a(i) {
    return function(o) {
      o = n(o);
      var s = t(o) ? r(o) : void 0, c = s ? s[0] : o.charAt(0), u = s ? e(s, 1).join("") : o.slice(1);
      return c[i]() + u;
    };
  }
  return vn = a, vn;
}
var gn, Ys;
function lg() {
  if (Ys) return gn;
  Ys = 1;
  var e = ug(), t = e("toUpperCase");
  return gn = t, gn;
}
var mn, Xs;
function fg() {
  if (Xs) return mn;
  Xs = 1;
  var e = pr(), t = lg();
  function r(n) {
    return t(e(n).toLowerCase());
  }
  return mn = r, mn;
}
var dg = fg();
const hg = /* @__PURE__ */ Re(dg), pg = we(
  function({
    visualization: t,
    visualizations: r,
    onChangeVisualization: n
  }) {
    return r.length <= 1 ? null : /* @__PURE__ */ y.jsx(Ol, { variant: "secondary", children: r.map((a) => /* @__PURE__ */ y.jsx(
      io,
      {
        icon: Ge.visualizationIcons[a],
        onClick: () => {
          n(a);
        },
        active: t === a,
        title: `${hg(a)} chart`
      },
      a
    )) });
  }
), vg = ({
  instrument: e,
  granularity: t,
  timezone: r,
  syncOptions: n
}) => {
  const { data: a, layout: i } = e, o = i === "horizontal", s = i === "vertical", c = 192, u = Y(() => {
    if (s) return 0;
    const g = a.categories.length % 2 === 0;
    switch (t) {
      // There are always an even number of categories, so we preserve the first tick in order to
      // ensure that hours are shown in even intervals e.g. 08:00, 10:00, 12:00 ... 22:00.
      case "H":
        return "preserveStart";
      // When the number of days is even, we preserve the last tick in order to ensure that
      // days are shown in equal intervals e.g. Apr 2, Apr 4, Apr 6 ... Apr 30. When uneven, we
      // preserve the first tick, resulting in equal intervals e.g. Mar 1, Mar 4, Mar 7 ... Mar 31.
      case "D":
      case "W":
        return g ? "preserveEnd" : "preserveStart";
      default:
        return "preserveStartEnd";
    }
  }, [a.categories.length, t, s]), d = {
    dataKey: "name",
    width: s ? c : 0,
    tickLine: {
      stroke: "var(--dixa-color-neutral-200)"
    },
    axisLine: {
      stroke: "var(--dixa-color-neutral-200)"
    },
    tickSize: 6,
    tickMargin: 8,
    interval: u,
    tick: Ge.tickProps,
    tickFormatter: (g) => or(g) ? Af(g, t, { timezone: r }) : Tf(g, { length: c / 10 })
  }, l = {
    domain: [0, "auto"],
    allowDecimals: !1,
    tickLine: !1,
    axisLine: !1,
    tick: Ge.tickProps,
    ticks: n?.ticks,
    tickCount: Ge.tickCount,
    tickFormatter: (g) => qt(g, a.series[0].options?.format ?? "number")
  }, h = o ? { type: "category", ...d } : { type: "number", ...l }, f = o ? { type: "number", ...l } : { type: "category", ...d };
  return { xAxisProps: h, yAxisProps: f };
};
var bn, Js;
function gg() {
  if (Js) return bn;
  Js = 1;
  var e = Oe(), t = function() {
    return e.Date.now();
  };
  return bn = t, bn;
}
var yn, Zs;
function mg() {
  if (Zs) return yn;
  Zs = 1;
  var e = Ze(), t = gg(), r = Of(), n = "Expected a function", a = Math.max, i = Math.min;
  function o(s, c, u) {
    var d, l, h, f, g, p, m = 0, b = !1, _ = !1, C = !0;
    if (typeof s != "function")
      throw new TypeError(n);
    c = r(c) || 0, e(u) && (b = !!u.leading, _ = "maxWait" in u, h = _ ? a(r(u.maxWait) || 0, c) : h, C = "trailing" in u ? !!u.trailing : C);
    function R($) {
      var M = d, F = l;
      return d = l = void 0, m = $, f = s.apply(F, M), f;
    }
    function P($) {
      return m = $, g = setTimeout(x, c), b ? R($) : f;
    }
    function O($) {
      var M = $ - p, F = $ - m, q = c - M;
      return _ ? i(q, h - F) : q;
    }
    function T($) {
      var M = $ - p, F = $ - m;
      return p === void 0 || M >= c || M < 0 || _ && F >= h;
    }
    function x() {
      var $ = t();
      if (T($))
        return w($);
      g = setTimeout(x, O($));
    }
    function w($) {
      return g = void 0, C && d ? R($) : (d = l = void 0, f);
    }
    function E() {
      g !== void 0 && clearTimeout(g), m = 0, d = p = l = g = void 0;
    }
    function S() {
      return g === void 0 ? f : w(t());
    }
    function I() {
      var $ = t(), M = T($);
      if (d = arguments, l = this, p = $, M) {
        if (g === void 0)
          return P(p);
        if (_)
          return clearTimeout(g), g = setTimeout(x, c), R(p);
      }
      return g === void 0 && (g = setTimeout(x, c)), f;
    }
    return I.cancel = E, I.flush = S, I;
  }
  return yn = o, yn;
}
var bg = mg();
const yg = /* @__PURE__ */ Re(bg), _g = "_legendItem_1mjjb_48", xg = "_legendItemInactive_1mjjb_55", wg = "_legendIcon_1mjjb_59", Cg = "_legendIconBar_1mjjb_66", Rg = "_legendIconLine_1mjjb_69", xt = {
  legendItem: _g,
  legendItemInactive: xg,
  legendIcon: wg,
  legendIconBar: Cg,
  legendIconLine: Rg
}, Sg = we(function({
  instrument: t,
  legend: r,
  visualization: n,
  onToggleLegendItem: a,
  onMouseEnterLegendItem: i,
  onMouseLeaveLegendItem: o,
  hoveredLegend: s
}) {
  const { series: c, options: u } = t.data, { layout: d } = u?.legend ?? {
    layout: "horizontal"
  }, l = d === "horizontal";
  return /* @__PURE__ */ y.jsx(
    K,
    {
      padding: l ? "0" : "0 0 0 400",
      flexDirection: l ? "row" : "column",
      gap: l ? "400" : "200",
      justifyContent: "center",
      children: c.map(({ label: h, options: f }, g) => {
        const p = ct(
          g,
          void 0,
          f?.color
        ), m = $e(xt.legendItem, {
          [xt.legendItemInactive]: s && s !== h
        }), b = $e(xt.legendIcon, {
          [xt.legendIconBar]: n !== "line",
          [xt.legendIconLine]: n === "line"
        });
        return /* @__PURE__ */ y.jsxs(
          K,
          {
            gap: "200",
            flexDirection: "row",
            alignItems: "center",
            className: m,
            onClick: () => a(h),
            onMouseEnter: () => i?.(h),
            onMouseLeave: () => o?.(h),
            children: [
              /* @__PURE__ */ y.jsx(
                "span",
                {
                  className: b,
                  style: {
                    borderColor: p,
                    backgroundColor: r.includes(h) ? p : "transparent"
                  }
                }
              ),
              /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", subdued: !0, children: h })
            ]
          },
          h
        );
      })
    }
  );
}), Pg = ({
  instrument: e,
  visualization: t
}) => {
  const {
    data: { series: r, options: n }
  } = e, a = n?.legend?.layout === "horizontal", [i, o] = md(
    r.filter(({ options: m }) => m?.visible ?? !0).map(({ label: m }) => m)
  ), [s, c] = Z(null);
  Tt(() => {
    u();
  }, [r.length]);
  const u = G(() => {
    o.set(r.map(({ label: m }) => m));
  }, [r, o]), d = G(
    (m) => {
      i.includes(m) && c(m);
    },
    [i]
  ), l = Y(
    () => yg(d, 300),
    [d]
  ), h = G(() => {
    l.cancel(), c(null);
  }, [l]), f = G(
    (m) => {
      i.length === r.length ? o.filter((b) => b === m) : i.length === 1 && i.includes(m) ? u() : i.includes(m) ? o.removeAt(i.indexOf(m)) : o.push(m);
    },
    [r.length, u, i, o]
  ), g = Y(
    () => r.length < 10 ? {
      onMouseEnterLegendItem: l,
      onMouseLeaveLegendItem: h,
      hoveredLegend: s
    } : {},
    [
      l,
      h,
      s,
      r.length
    ]
  ), p = Y(
    () => ({
      layout: n?.legend?.layout,
      align: a ? "center" : "right",
      verticalAlign: a ? "bottom" : "middle",
      wrapperStyle: {
        overflow: "auto",
        ...a ? {
          bottom: 0
        } : {
          right: 0,
          width: 208,
          maxHeight: "100%"
        }
      },
      // Using the render function form instead of directly passing an element prevents the
      // `ChartInstrumentLegend` component from re-rendering unnecessarily due to Recharts props
      // changing, because Recharts automatically passes props to the `content` element.
      content: () => /* @__PURE__ */ y.jsx(
        Sg,
        {
          visualization: t,
          instrument: e,
          legend: i,
          onToggleLegendItem: f,
          ...g
        }
      )
    }),
    [
      f,
      e,
      a,
      i,
      g,
      n?.legend?.layout,
      t
    ]
  );
  return {
    legend: i,
    legendProps: p,
    hoveredLegend: s
  };
};
var _n, Qs;
function Eg() {
  if (Qs) return _n;
  Qs = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return _n = e, _n;
}
var Og = Eg();
const Ag = /* @__PURE__ */ Re(Og);
var xn, ec;
function bo() {
  if (ec) return xn;
  ec = 1;
  var e = Se(), t = It(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function a(i, o) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : n.test(i) || !r.test(i) || o != null && i in Object(o);
  }
  return xn = a, xn;
}
var wn, tc;
function $f() {
  if (tc) return wn;
  tc = 1;
  var e = Xe(), t = Ze(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", i = "[object Proxy]";
  function o(s) {
    if (!t(s))
      return !1;
    var c = e(s);
    return c == n || c == a || c == r || c == i;
  }
  return wn = o, wn;
}
var Cn, rc;
function Tg() {
  if (rc) return Cn;
  rc = 1;
  var e = Oe(), t = e["__core-js_shared__"];
  return Cn = t, Cn;
}
var Rn, nc;
function $g() {
  if (nc) return Rn;
  nc = 1;
  var e = Tg(), t = function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function r(n) {
    return !!t && t in n;
  }
  return Rn = r, Rn;
}
var Sn, ac;
function qf() {
  if (ac) return Sn;
  ac = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return Sn = r, Sn;
}
var Pn, ic;
function qg() {
  if (ic) return Pn;
  ic = 1;
  var e = $f(), t = $g(), r = Ze(), n = qf(), a = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, o = Function.prototype, s = Object.prototype, c = o.toString, u = s.hasOwnProperty, d = RegExp(
    "^" + c.call(u).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function l(h) {
    if (!r(h) || t(h))
      return !1;
    var f = e(h) ? d : i;
    return f.test(n(h));
  }
  return Pn = l, Pn;
}
var En, oc;
function jg() {
  if (oc) return En;
  oc = 1;
  function e(t, r) {
    return t?.[r];
  }
  return En = e, En;
}
var On, sc;
function Qe() {
  if (sc) return On;
  sc = 1;
  var e = qg(), t = jg();
  function r(n, a) {
    var i = t(n, a);
    return e(i) ? i : void 0;
  }
  return On = r, On;
}
var An, cc;
function vr() {
  if (cc) return An;
  cc = 1;
  var e = Qe(), t = e(Object, "create");
  return An = t, An;
}
var Tn, uc;
function Ig() {
  if (uc) return Tn;
  uc = 1;
  var e = vr();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Tn = t, Tn;
}
var $n, lc;
function Mg() {
  if (lc) return $n;
  lc = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return $n = e, $n;
}
var qn, fc;
function Dg() {
  if (fc) return qn;
  fc = 1;
  var e = vr(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    var o = this.__data__;
    if (e) {
      var s = o[i];
      return s === t ? void 0 : s;
    }
    return n.call(o, i) ? o[i] : void 0;
  }
  return qn = a, qn;
}
var jn, dc;
function Fg() {
  if (dc) return jn;
  dc = 1;
  var e = vr(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var i = this.__data__;
    return e ? i[a] !== void 0 : r.call(i, a);
  }
  return jn = n, jn;
}
var In, hc;
function Ng() {
  if (hc) return In;
  hc = 1;
  var e = vr(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var i = this.__data__;
    return this.size += this.has(n) ? 0 : 1, i[n] = e && a === void 0 ? t : a, this;
  }
  return In = r, In;
}
var Mn, pc;
function Lg() {
  if (pc) return Mn;
  pc = 1;
  var e = Ig(), t = Mg(), r = Dg(), n = Fg(), a = Ng();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Mn = i, Mn;
}
var Dn, vc;
function kg() {
  if (vc) return Dn;
  vc = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Dn = e, Dn;
}
var Fn, gc;
function yo() {
  if (gc) return Fn;
  gc = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Fn = e, Fn;
}
var Nn, mc;
function gr() {
  if (mc) return Nn;
  mc = 1;
  var e = yo();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return Nn = t, Nn;
}
var Ln, bc;
function Vg() {
  if (bc) return Ln;
  bc = 1;
  var e = gr(), t = Array.prototype, r = t.splice;
  function n(a) {
    var i = this.__data__, o = e(i, a);
    if (o < 0)
      return !1;
    var s = i.length - 1;
    return o == s ? i.pop() : r.call(i, o, 1), --this.size, !0;
  }
  return Ln = n, Ln;
}
var kn, yc;
function Bg() {
  if (yc) return kn;
  yc = 1;
  var e = gr();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return kn = t, kn;
}
var Vn, _c;
function Hg() {
  if (_c) return Vn;
  _c = 1;
  var e = gr();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Vn = t, Vn;
}
var Bn, xc;
function zg() {
  if (xc) return Bn;
  xc = 1;
  var e = gr();
  function t(r, n) {
    var a = this.__data__, i = e(a, r);
    return i < 0 ? (++this.size, a.push([r, n])) : a[i][1] = n, this;
  }
  return Bn = t, Bn;
}
var Hn, wc;
function mr() {
  if (wc) return Hn;
  wc = 1;
  var e = kg(), t = Vg(), r = Bg(), n = Hg(), a = zg();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Hn = i, Hn;
}
var zn, Cc;
function _o() {
  if (Cc) return zn;
  Cc = 1;
  var e = Qe(), t = Oe(), r = e(t, "Map");
  return zn = r, zn;
}
var Un, Rc;
function Ug() {
  if (Rc) return Un;
  Rc = 1;
  var e = Lg(), t = mr(), r = _o();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Un = n, Un;
}
var Wn, Sc;
function Wg() {
  if (Sc) return Wn;
  Sc = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Wn = e, Wn;
}
var Gn, Pc;
function br() {
  if (Pc) return Gn;
  Pc = 1;
  var e = Wg();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return Gn = t, Gn;
}
var Kn, Ec;
function Gg() {
  if (Ec) return Kn;
  Ec = 1;
  var e = br();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Kn = t, Kn;
}
var Yn, Oc;
function Kg() {
  if (Oc) return Yn;
  Oc = 1;
  var e = br();
  function t(r) {
    return e(this, r).get(r);
  }
  return Yn = t, Yn;
}
var Xn, Ac;
function Yg() {
  if (Ac) return Xn;
  Ac = 1;
  var e = br();
  function t(r) {
    return e(this, r).has(r);
  }
  return Xn = t, Xn;
}
var Jn, Tc;
function Xg() {
  if (Tc) return Jn;
  Tc = 1;
  var e = br();
  function t(r, n) {
    var a = e(this, r), i = a.size;
    return a.set(r, n), this.size += a.size == i ? 0 : 1, this;
  }
  return Jn = t, Jn;
}
var Zn, $c;
function xo() {
  if ($c) return Zn;
  $c = 1;
  var e = Ug(), t = Gg(), r = Kg(), n = Yg(), a = Xg();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Zn = i, Zn;
}
var Qn, qc;
function Jg() {
  if (qc) return Qn;
  qc = 1;
  var e = xo(), t = "Expected a function";
  function r(n, a) {
    if (typeof n != "function" || a != null && typeof a != "function")
      throw new TypeError(t);
    var i = function() {
      var o = arguments, s = a ? a.apply(this, o) : o[0], c = i.cache;
      if (c.has(s))
        return c.get(s);
      var u = n.apply(this, o);
      return i.cache = c.set(s, u) || c, u;
    };
    return i.cache = new (r.Cache || e)(), i;
  }
  return r.Cache = e, Qn = r, Qn;
}
var ea, jc;
function Zg() {
  if (jc) return ea;
  jc = 1;
  var e = Jg(), t = 500;
  function r(n) {
    var a = e(n, function(o) {
      return i.size === t && i.clear(), o;
    }), i = a.cache;
    return a;
  }
  return ea = r, ea;
}
var ta, Ic;
function Qg() {
  if (Ic) return ta;
  Ic = 1;
  var e = Zg(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(a) {
    var i = [];
    return a.charCodeAt(0) === 46 && i.push(""), a.replace(t, function(o, s, c, u) {
      i.push(c ? u.replace(r, "$1") : s || o);
    }), i;
  });
  return ta = n, ta;
}
var ra, Mc;
function yr() {
  if (Mc) return ra;
  Mc = 1;
  var e = Se(), t = bo(), r = Qg(), n = pr();
  function a(i, o) {
    return e(i) ? i : t(i, o) ? [i] : r(n(i));
  }
  return ra = a, ra;
}
var na, Dc;
function Mt() {
  if (Dc) return na;
  Dc = 1;
  var e = It();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return na = t, na;
}
var aa, Fc;
function _r() {
  if (Fc) return aa;
  Fc = 1;
  var e = yr(), t = Mt();
  function r(n, a) {
    a = e(a, n);
    for (var i = 0, o = a.length; n != null && i < o; )
      n = n[t(a[i++])];
    return i && i == o ? n : void 0;
  }
  return aa = r, aa;
}
var ia, Nc;
function jf() {
  if (Nc) return ia;
  Nc = 1;
  var e = Qe(), t = function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  }();
  return ia = t, ia;
}
var oa, Lc;
function em() {
  if (Lc) return oa;
  Lc = 1;
  var e = jf();
  function t(r, n, a) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return oa = t, oa;
}
var sa, kc;
function tm() {
  if (kc) return sa;
  kc = 1;
  var e = em(), t = yo(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i, o, s) {
    var c = i[o];
    (!(n.call(i, o) && t(c, s)) || s === void 0 && !(o in i)) && e(i, o, s);
  }
  return sa = a, sa;
}
var ca, Vc;
function wo() {
  if (Vc) return ca;
  Vc = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var i = typeof n;
    return a = a ?? e, !!a && (i == "number" || i != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return ca = r, ca;
}
var ua, Bc;
function rm() {
  if (Bc) return ua;
  Bc = 1;
  var e = tm(), t = yr(), r = wo(), n = Ze(), a = Mt();
  function i(o, s, c, u) {
    if (!n(o))
      return o;
    s = t(s, o);
    for (var d = -1, l = s.length, h = l - 1, f = o; f != null && ++d < l; ) {
      var g = a(s[d]), p = c;
      if (g === "__proto__" || g === "constructor" || g === "prototype")
        return o;
      if (d != h) {
        var m = f[g];
        p = u ? u(m, g, f) : void 0, p === void 0 && (p = n(m) ? m : r(s[d + 1]) ? [] : {});
      }
      e(f, g, p), f = f[g];
    }
    return o;
  }
  return ua = i, ua;
}
var la, Hc;
function nm() {
  if (Hc) return la;
  Hc = 1;
  var e = _r(), t = rm(), r = yr();
  function n(a, i, o) {
    for (var s = -1, c = i.length, u = {}; ++s < c; ) {
      var d = i[s], l = e(a, d);
      o(l, d) && t(u, r(d, a), l);
    }
    return u;
  }
  return la = n, la;
}
var fa, zc;
function am() {
  if (zc) return fa;
  zc = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return fa = e, fa;
}
var da, Uc;
function im() {
  if (Uc) return da;
  Uc = 1;
  var e = Xe(), t = Je(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return da = n, da;
}
var ha, Wc;
function Co() {
  if (Wc) return ha;
  Wc = 1;
  var e = im(), t = Je(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(o) {
    return t(o) && n.call(o, "callee") && !a.call(o, "callee");
  };
  return ha = i, ha;
}
var pa, Gc;
function Ro() {
  if (Gc) return pa;
  Gc = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return pa = t, pa;
}
var va, Kc;
function om() {
  if (Kc) return va;
  Kc = 1;
  var e = yr(), t = Co(), r = Se(), n = wo(), a = Ro(), i = Mt();
  function o(s, c, u) {
    c = e(c, s);
    for (var d = -1, l = c.length, h = !1; ++d < l; ) {
      var f = i(c[d]);
      if (!(h = s != null && u(s, f)))
        break;
      s = s[f];
    }
    return h || ++d != l ? h : (l = s == null ? 0 : s.length, !!l && a(l) && n(f, l) && (r(s) || t(s)));
  }
  return va = o, va;
}
var ga, Yc;
function If() {
  if (Yc) return ga;
  Yc = 1;
  var e = am(), t = om();
  function r(n, a) {
    return n != null && t(n, a, e);
  }
  return ga = r, ga;
}
var ma, Xc;
function sm() {
  if (Xc) return ma;
  Xc = 1;
  var e = nm(), t = If();
  function r(n, a) {
    return e(n, a, function(i, o) {
      return t(n, o);
    });
  }
  return ma = r, ma;
}
var ba, Jc;
function Mf() {
  if (Jc) return ba;
  Jc = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, i = t.length; ++n < a; )
      t[i + n] = r[n];
    return t;
  }
  return ba = e, ba;
}
var ya, Zc;
function cm() {
  if (Zc) return ya;
  Zc = 1;
  var e = jt(), t = Co(), r = Se(), n = e ? e.isConcatSpreadable : void 0;
  function a(i) {
    return r(i) || t(i) || !!(n && i && i[n]);
  }
  return ya = a, ya;
}
var _a, Qc;
function um() {
  if (Qc) return _a;
  Qc = 1;
  var e = Mf(), t = cm();
  function r(n, a, i, o, s) {
    var c = -1, u = n.length;
    for (i || (i = t), s || (s = []); ++c < u; ) {
      var d = n[c];
      a > 0 && i(d) ? a > 1 ? r(d, a - 1, i, o, s) : e(s, d) : o || (s[s.length] = d);
    }
    return s;
  }
  return _a = r, _a;
}
var xa, eu;
function lm() {
  if (eu) return xa;
  eu = 1;
  var e = um();
  function t(r) {
    var n = r == null ? 0 : r.length;
    return n ? e(r, 1) : [];
  }
  return xa = t, xa;
}
var wa, tu;
function fm() {
  if (tu) return wa;
  tu = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return wa = e, wa;
}
var Ca, ru;
function dm() {
  if (ru) return Ca;
  ru = 1;
  var e = fm(), t = Math.max;
  function r(n, a, i) {
    return a = t(a === void 0 ? n.length - 1 : a, 0), function() {
      for (var o = arguments, s = -1, c = t(o.length - a, 0), u = Array(c); ++s < c; )
        u[s] = o[a + s];
      s = -1;
      for (var d = Array(a + 1); ++s < a; )
        d[s] = o[s];
      return d[a] = i(u), e(n, this, d);
    };
  }
  return Ca = r, Ca;
}
var Ra, nu;
function hm() {
  if (nu) return Ra;
  nu = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Ra = e, Ra;
}
var Sa, au;
function xr() {
  if (au) return Sa;
  au = 1;
  function e(t) {
    return t;
  }
  return Sa = e, Sa;
}
var Pa, iu;
function pm() {
  if (iu) return Pa;
  iu = 1;
  var e = hm(), t = jf(), r = xr(), n = t ? function(a, i) {
    return t(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : r;
  return Pa = n, Pa;
}
var Ea, ou;
function vm() {
  if (ou) return Ea;
  ou = 1;
  var e = 800, t = 16, r = Date.now;
  function n(a) {
    var i = 0, o = 0;
    return function() {
      var s = r(), c = t - (s - o);
      if (o = s, c > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Ea = n, Ea;
}
var Oa, su;
function gm() {
  if (su) return Oa;
  su = 1;
  var e = pm(), t = vm(), r = t(e);
  return Oa = r, Oa;
}
var Aa, cu;
function mm() {
  if (cu) return Aa;
  cu = 1;
  var e = lm(), t = dm(), r = gm();
  function n(a) {
    return r(t(a, void 0, e), a + "");
  }
  return Aa = n, Aa;
}
var Ta, uu;
function bm() {
  if (uu) return Ta;
  uu = 1;
  var e = sm(), t = mm(), r = t(function(n, a) {
    return n == null ? {} : e(n, a);
  });
  return Ta = r, Ta;
}
var ym = bm();
const _m = /* @__PURE__ */ Re(ym);
var $a, lu;
function xm() {
  if (lu) return $a;
  lu = 1;
  function e(t, r) {
    for (var n, a = -1, i = t.length; ++a < i; ) {
      var o = r(t[a]);
      o !== void 0 && (n = n === void 0 ? o : n + o);
    }
    return n;
  }
  return $a = e, $a;
}
var qa, fu;
function wm() {
  if (fu) return qa;
  fu = 1;
  var e = xm(), t = xr();
  function r(n) {
    return n && n.length ? e(n, t) : 0;
  }
  return qa = r, qa;
}
var Cm = wm();
const Rm = /* @__PURE__ */ Re(Cm), Sm = (e) => {
  const { outerRadius: t } = e;
  return /* @__PURE__ */ y.jsxs("g", { children: [
    /* @__PURE__ */ y.jsx(ko, { ...e }),
    /* @__PURE__ */ y.jsx(
      ko,
      {
        ...e,
        innerRadius: t,
        outerRadius: t + 10,
        fillOpacity: 0.4
      }
    )
  ] });
}, Pm = (e) => {
  const { name: t, value: r, cx: n, cy: a, midAngle: i, outerRadius: o, fill: s, percent: c } = e, u = !!r, d = typeof c == "number" && c >= 0.01;
  if (!u || !d || !(typeof n == "number" && typeof a == "number" && typeof i == "number" && typeof o == "number"))
    return null;
  const h = Math.PI / 180, f = o + 24, g = n + o * Math.cos(-i * h), p = a + o * Math.sin(-i * h), m = n + f * Math.cos(-i * h), b = a + f * Math.sin(-i * h), _ = m + (m > n ? 12 : -12), C = b;
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      "polyline",
      {
        points: `${g},${p} ${m},${b} ${_},${C}`,
        stroke: s,
        fill: "none",
        strokeWidth: 1
      }
    ),
    /* @__PURE__ */ y.jsx(
      "text",
      {
        ...Ge.tickProps,
        fill: Dd.color.secondary,
        x: _ + (_ > n ? 8 : -8),
        y: C,
        textAnchor: _ > n ? "start" : "end",
        dominantBaseline: "middle",
        children: t
      }
    )
  ] });
}, Em = ({
  instrument: e,
  legend: t,
  hoveredLegend: r,
  hoveredCategory: n
}) => {
  const { data: a, layout: i } = e, o = G(() => {
    const { categories: l, series: h } = a, f = h.filter(({ label: b }) => t.includes(b)), g = i === "vertical", p = g ? [0, 2, 2, 0] : [2, 2, 0, 0];
    return h.map(
      ({ label: b, options: _, data: C }, R) => {
        const P = ct(
          R,
          a.options?.theme,
          _?.color
        ), O = _?.stack, T = O ? Ag(f)?.label === b : !0, x = f.length <= 10 && (O ? T : !0), w = /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
          x && /* @__PURE__ */ y.jsx(
            yd,
            {
              position: g ? "right" : "top",
              valueAccessor: ({ payload: S }) => (
                // In the case of stacked series, the total sum of all
                // visible series values for the current category is
                // displayed. For individual series, their own value is
                // displayed by using their `label` from the Recharts data.
                O ? Rm(Object.values(_m(S, t))) : Number(S[b] ?? 0)
              ),
              formatter: (S) => S ? qt(S, _?.format ?? "number") : "",
              ...Ge.tickProps,
              offset: 8,
              fontSize: "var(--dixa-typography-size-100)"
            }
          ),
          C.map((S, I) => {
            const $ = h.length > 1 ? P : ct(
              I,
              a.options?.theme,
              // If there is only one series, the category color is used if specified, otherwise
              // the colors are determined by the category index, resulting in different colors
              // being used for each category and repeating as necessary.
              l[I]?.options?.color ?? _?.color
            ), M = n === null || n === I, F = r === null || r === b;
            return /* @__PURE__ */ y.jsx(
              Vo,
              {
                fill: $,
                fillOpacity: M && F ? 1 : 0.4
              },
              `${b}-${I}`
            );
          })
        ] });
        return {
          key: b,
          dataKey: b,
          stackId: O,
          fill: P,
          radius: T ? p : 0,
          maxBarSize: 80,
          hide: !t.includes(b),
          children: w
        };
      }
    );
  }, [a, n, r, i, t]), s = G(() => {
    const { series: l } = a;
    return l.map(({ label: f, options: g }, p) => {
      const m = ct(
        p,
        a.options?.theme,
        g?.color
      );
      return {
        key: f,
        type: "monotone",
        dot: !1,
        activeDot: { r: 5 },
        dataKey: f,
        stroke: m,
        strokeWidth: 2,
        strokeOpacity: r === null || r === f ? 1 : 0.4,
        connectNulls: !0,
        hide: !t.includes(f)
      };
    });
  }, [a, r, t]), c = G(() => {
    const { series: l } = a;
    return l.map(({ label: f, options: g }, p) => {
      const m = ct(
        p,
        a.options?.theme,
        g?.color
      ), b = r === null || r === f;
      return {
        key: f,
        type: "monotone",
        dot: !1,
        activeDot: { r: 5 },
        dataKey: f,
        stackId: g?.stack,
        stroke: m,
        strokeWidth: 2,
        fill: m,
        fillOpacity: b ? 0.9 : 0.2,
        strokeOpacity: b ? 1 : 0,
        connectNulls: !0,
        hide: !t.includes(f)
      };
    });
  }, [a, r, t]), u = G(
    (l) => {
      const { categories: h, series: f } = a, g = h.map(
        ({ label: p, options: m }, b) => {
          const _ = ct(
            b,
            a.options?.theme,
            m?.color
          );
          return /* @__PURE__ */ y.jsx(Vo, { fill: _, style: { outline: "none" } }, p);
        }
      );
      return {
        dataKey: f[0]?.label,
        cx: "50%",
        cy: "50%",
        label: Pm,
        labelLine: !1,
        activeShape: Sm,
        inactiveShape: {
          fillOpacity: 0.4
        },
        stroke: jl.neutral["000"],
        strokeWidth: 1.5,
        innerRadius: l === "donut" ? "50%" : 0,
        outerRadius: "80%",
        startAngle: 90,
        endAngle: -270,
        children: g
      };
    },
    [a]
  );
  return { getSeriesProps: G(
    (l) => {
      switch (l) {
        case "bar":
          return o();
        case "line":
          return s();
        case "area":
          return c();
        case "pie":
        case "donut":
          return u(
            l
          );
        default:
          return [];
      }
      return [];
    },
    [c, o, s, u]
  ) };
}, Ty = we(function({
  instrument: t,
  panel: r,
  timezone: n,
  syncOptions: a,
  onChangeGranularity: i,
  onChangeVisualization: o
}) {
  const [s, c] = Z(
    r.controls?.settings.visualization ?? t.visualization
  ), [u, d] = Z(null), { data: l, layout: h, title: f } = t, g = h === "horizontal", p = h === "vertical", m = Y(
    () => Bv(l, { omitZero: s === "bar" }),
    [l, s]
  ), b = Y(
    () => l.granularities?.find(({ selected: q }) => q)?.value,
    [l.granularities]
  ), _ = Y(() => {
    if (!l.options?.visualizations) return [];
    const q = ["bar"], L = l.series.length === 1;
    return l.categories.every(
      ({ label: Q }) => or(Q)
    ) ? q.push("line", "area") : L && q.push("pie", "donut"), q;
  }, [l.categories, l.options?.visualizations, l.series.length]), { xAxisProps: C, yAxisProps: R } = vg({
    instrument: t,
    granularity: b,
    timezone: n,
    syncOptions: a
  }), { legend: P, legendProps: O, hoveredLegend: T } = Pg({
    instrument: t,
    visualization: s
  }), { getSeriesProps: x } = Em({
    instrument: t,
    legend: P,
    hoveredLegend: T,
    hoveredCategory: u
  });
  Tt(() => {
    c(
      r.controls?.settings.visualization ?? t.visualization
    );
  }, [r.controls?.settings.visualization, t.visualization]);
  const w = G(
    (q) => {
      c(q), o?.(q);
    },
    [o]
  ), E = (q) => {
    if (!q?.isTooltipActive) {
      d(null);
      return;
    }
    const L = q.activeTooltipIndex;
    if (typeof L != "number") return;
    const k = Object.values(m[L] ?? {}).length > 1;
    d(k ? L : null);
  }, S = () => {
    d(null);
  }, I = () => s === "line" ? x(s).map(({ key: L, ...k }) => /* @__PURE__ */ y.jsx(qd, { ...k }, L)) : s === "bar" ? x(s).map(({ key: L, ...k }) => /* @__PURE__ */ y.jsx(jd, { ...k }, L)) : s === "area" ? x(s).map(({ key: L, ...k }) => /* @__PURE__ */ y.jsx(Id, { ...k }, L)) : s === "pie" || s === "donut" ? /* @__PURE__ */ y.jsx(Md, { data: m, ...x(s) }) : null, $ = () => {
    const q = l.options?.legend?.layout, L = 16, k = {
      layout: h,
      syncId: a?.tooltip ? r.id : void 0,
      data: m,
      margin: {
        top: g ? L : 0,
        right: p || q === "vertical" ? L : 0,
        bottom: q === "horizontal" ? L / 2 : 0,
        left: 0
      }
    }, Q = s === "bar" || s === "line" || s === "area", re = /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      Q && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        /* @__PURE__ */ y.jsx(xd, { ...C }),
        /* @__PURE__ */ y.jsx(wd, { ...R })
      ] }),
      Q && l.options?.cartesian && /* @__PURE__ */ y.jsx(
        Cd,
        {
          vertical: p,
          horizontal: g,
          stroke: "var(--dixa-color-neutral-200)"
        }
      ),
      Q && l.references?.map(({ value: te, label: he }, oe) => /* @__PURE__ */ y.jsx(
        Rd,
        {
          ...g ? { y: te } : { x: te },
          stroke: "var(--dixa-color-neutral-500)",
          strokeDasharray: "5 5",
          isFront: !0,
          children: /* @__PURE__ */ y.jsx(
            Sd,
            {
              value: he,
              offset: 8,
              fontSize: "var(--dixa-typography-size-200)",
              position: g ? "insideBottomLeft" : "insideTopLeft"
            }
          )
        },
        oe
      )),
      l.options?.legend && /* @__PURE__ */ y.jsx(Pd, { ...O }),
      l.options?.tooltip && /* @__PURE__ */ y.jsx(
        Ed,
        {
          content: (te) => /* @__PURE__ */ y.jsx(
            cg,
            {
              instrument: t,
              granularity: b,
              timezone: n,
              tooltipProps: te
            }
          ),
          cursor: { fill: "transparent" }
        }
      ),
      I()
    ] });
    switch (s) {
      case "bar":
        return /* @__PURE__ */ y.jsx(
          $d,
          {
            ...k,
            barGap: "1",
            onMouseMove: E,
            onMouseLeave: S,
            children: re
          }
        );
      case "line":
        return /* @__PURE__ */ y.jsx(Td, { ...k, children: re });
      case "area":
        return /* @__PURE__ */ y.jsx(Ad, { ...k, children: re });
      case "pie":
      case "donut":
        return /* @__PURE__ */ y.jsx(Od, { ...k, children: re });
    }
  };
  if (!l.categories.length || !l.series.length)
    return /* @__PURE__ */ y.jsx(
      K,
      {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        children: /* @__PURE__ */ y.jsx(
          Tl,
          {
            title: "No data available",
            description: "There is no data available for the selected period and filters.",
            icon: Ge.visualizationIcons[s]
          }
        )
      }
    );
  const M = [
    l.granularities && l.granularities.length > 1 ? /* @__PURE__ */ y.jsx(
      Tv,
      {
        granularities: l.granularities,
        onChangeGranularity: i
      }
    ) : null,
    l.options?.visualizations ? /* @__PURE__ */ y.jsx(
      pg,
      {
        visualization: s,
        visualizations: _,
        onChangeVisualization: w
      }
    ) : null
  ], F = M.some(Boolean);
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    f && /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(W.Heading, { variant: "heading-4", children: f }) }),
    F && /* @__PURE__ */ y.jsx(K, { alignSelf: "flex-end", gap: "300", children: M.map((q, L) => /* @__PURE__ */ y.jsx(El, { children: q }, L)) }),
    /* @__PURE__ */ y.jsx(
      _d,
      {
        className: Av.container,
        width: "100%",
        height: "100%",
        debounce: 100,
        children: $()
      }
    )
  ] });
});
var ja, du;
function Om() {
  if (du) return ja;
  du = 1;
  var e = mr();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return ja = t, ja;
}
var Ia, hu;
function Am() {
  if (hu) return Ia;
  hu = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Ia = e, Ia;
}
var Ma, pu;
function Tm() {
  if (pu) return Ma;
  pu = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Ma = e, Ma;
}
var Da, vu;
function $m() {
  if (vu) return Da;
  vu = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Da = e, Da;
}
var Fa, gu;
function qm() {
  if (gu) return Fa;
  gu = 1;
  var e = mr(), t = _o(), r = xo(), n = 200;
  function a(i, o) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!t || c.length < n - 1)
        return c.push([i, o]), this.size = ++s.size, this;
      s = this.__data__ = new r(c);
    }
    return s.set(i, o), this.size = s.size, this;
  }
  return Fa = a, Fa;
}
var Na, mu;
function Df() {
  if (mu) return Na;
  mu = 1;
  var e = mr(), t = Om(), r = Am(), n = Tm(), a = $m(), i = qm();
  function o(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return o.prototype.clear = t, o.prototype.delete = r, o.prototype.get = n, o.prototype.has = a, o.prototype.set = i, Na = o, Na;
}
var La, bu;
function jm() {
  if (bu) return La;
  bu = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return La = t, La;
}
var ka, yu;
function Im() {
  if (yu) return ka;
  yu = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return ka = e, ka;
}
var Va, _u;
function Mm() {
  if (_u) return Va;
  _u = 1;
  var e = xo(), t = jm(), r = Im();
  function n(a) {
    var i = -1, o = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++i < o; )
      this.add(a[i]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, Va = n, Va;
}
var Ba, xu;
function Dm() {
  if (xu) return Ba;
  xu = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Ba = e, Ba;
}
var Ha, wu;
function Fm() {
  if (wu) return Ha;
  wu = 1;
  function e(t, r) {
    return t.has(r);
  }
  return Ha = e, Ha;
}
var za, Cu;
function Ff() {
  if (Cu) return za;
  Cu = 1;
  var e = Mm(), t = Dm(), r = Fm(), n = 1, a = 2;
  function i(o, s, c, u, d, l) {
    var h = c & n, f = o.length, g = s.length;
    if (f != g && !(h && g > f))
      return !1;
    var p = l.get(o), m = l.get(s);
    if (p && m)
      return p == s && m == o;
    var b = -1, _ = !0, C = c & a ? new e() : void 0;
    for (l.set(o, s), l.set(s, o); ++b < f; ) {
      var R = o[b], P = s[b];
      if (u)
        var O = h ? u(P, R, b, s, o, l) : u(R, P, b, o, s, l);
      if (O !== void 0) {
        if (O)
          continue;
        _ = !1;
        break;
      }
      if (C) {
        if (!t(s, function(T, x) {
          if (!r(C, x) && (R === T || d(R, T, c, u, l)))
            return C.push(x);
        })) {
          _ = !1;
          break;
        }
      } else if (!(R === P || d(R, P, c, u, l))) {
        _ = !1;
        break;
      }
    }
    return l.delete(o), l.delete(s), _;
  }
  return za = i, za;
}
var Ua, Ru;
function Nm() {
  if (Ru) return Ua;
  Ru = 1;
  var e = Oe(), t = e.Uint8Array;
  return Ua = t, Ua;
}
var Wa, Su;
function Lm() {
  if (Su) return Wa;
  Su = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, i) {
      n[++r] = [i, a];
    }), n;
  }
  return Wa = e, Wa;
}
var Ga, Pu;
function km() {
  if (Pu) return Ga;
  Pu = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return Ga = e, Ga;
}
var Ka, Eu;
function Vm() {
  if (Eu) return Ka;
  Eu = 1;
  var e = jt(), t = Nm(), r = yo(), n = Ff(), a = Lm(), i = km(), o = 1, s = 2, c = "[object Boolean]", u = "[object Date]", d = "[object Error]", l = "[object Map]", h = "[object Number]", f = "[object RegExp]", g = "[object Set]", p = "[object String]", m = "[object Symbol]", b = "[object ArrayBuffer]", _ = "[object DataView]", C = e ? e.prototype : void 0, R = C ? C.valueOf : void 0;
  function P(O, T, x, w, E, S, I) {
    switch (x) {
      case _:
        if (O.byteLength != T.byteLength || O.byteOffset != T.byteOffset)
          return !1;
        O = O.buffer, T = T.buffer;
      case b:
        return !(O.byteLength != T.byteLength || !S(new t(O), new t(T)));
      case c:
      case u:
      case h:
        return r(+O, +T);
      case d:
        return O.name == T.name && O.message == T.message;
      case f:
      case p:
        return O == T + "";
      case l:
        var $ = a;
      case g:
        var M = w & o;
        if ($ || ($ = i), O.size != T.size && !M)
          return !1;
        var F = I.get(O);
        if (F)
          return F == T;
        w |= s, I.set(O, T);
        var q = n($(O), $(T), w, E, S, I);
        return I.delete(O), q;
      case m:
        if (R)
          return R.call(O) == R.call(T);
    }
    return !1;
  }
  return Ka = P, Ka;
}
var Ya, Ou;
function Bm() {
  if (Ou) return Ya;
  Ou = 1;
  var e = Mf(), t = Se();
  function r(n, a, i) {
    var o = a(n);
    return t(n) ? o : e(o, i(n));
  }
  return Ya = r, Ya;
}
var Xa, Au;
function Hm() {
  if (Au) return Xa;
  Au = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = 0, o = []; ++n < a; ) {
      var s = t[n];
      r(s, n, t) && (o[i++] = s);
    }
    return o;
  }
  return Xa = e, Xa;
}
var Ja, Tu;
function zm() {
  if (Tu) return Ja;
  Tu = 1;
  function e() {
    return [];
  }
  return Ja = e, Ja;
}
var Za, $u;
function Um() {
  if ($u) return Za;
  $u = 1;
  var e = Hm(), t = zm(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, i = a ? function(o) {
    return o == null ? [] : (o = Object(o), e(a(o), function(s) {
      return n.call(o, s);
    }));
  } : t;
  return Za = i, Za;
}
var Qa, qu;
function Wm() {
  if (qu) return Qa;
  qu = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return Qa = e, Qa;
}
var St = { exports: {} }, ei, ju;
function Gm() {
  if (ju) return ei;
  ju = 1;
  function e() {
    return !1;
  }
  return ei = e, ei;
}
St.exports;
var Iu;
function Nf() {
  return Iu || (Iu = 1, function(e, t) {
    var r = Oe(), n = Gm(), a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, c = s ? s.isBuffer : void 0, u = c || n;
    e.exports = u;
  }(St, St.exports)), St.exports;
}
var ti, Mu;
function Km() {
  if (Mu) return ti;
  Mu = 1;
  var e = Xe(), t = Ro(), r = Je(), n = "[object Arguments]", a = "[object Array]", i = "[object Boolean]", o = "[object Date]", s = "[object Error]", c = "[object Function]", u = "[object Map]", d = "[object Number]", l = "[object Object]", h = "[object RegExp]", f = "[object Set]", g = "[object String]", p = "[object WeakMap]", m = "[object ArrayBuffer]", b = "[object DataView]", _ = "[object Float32Array]", C = "[object Float64Array]", R = "[object Int8Array]", P = "[object Int16Array]", O = "[object Int32Array]", T = "[object Uint8Array]", x = "[object Uint8ClampedArray]", w = "[object Uint16Array]", E = "[object Uint32Array]", S = {};
  S[_] = S[C] = S[R] = S[P] = S[O] = S[T] = S[x] = S[w] = S[E] = !0, S[n] = S[a] = S[m] = S[i] = S[b] = S[o] = S[s] = S[c] = S[u] = S[d] = S[l] = S[h] = S[f] = S[g] = S[p] = !1;
  function I($) {
    return r($) && t($.length) && !!S[e($)];
  }
  return ti = I, ti;
}
var ri, Du;
function Lf() {
  if (Du) return ri;
  Du = 1;
  var e = Km(), t = mo(), r = Sf(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return ri = a, ri;
}
var ni, Fu;
function Ym() {
  if (Fu) return ni;
  Fu = 1;
  var e = Wm(), t = Co(), r = Se(), n = Nf(), a = wo(), i = Lf(), o = Object.prototype, s = o.hasOwnProperty;
  function c(u, d) {
    var l = r(u), h = !l && t(u), f = !l && !h && n(u), g = !l && !h && !f && i(u), p = l || h || f || g, m = p ? e(u.length, String) : [], b = m.length;
    for (var _ in u)
      (d || s.call(u, _)) && !(p && // Safari 9 has enumerable `arguments.length` in strict mode.
      (_ == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      f && (_ == "offset" || _ == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (_ == "buffer" || _ == "byteLength" || _ == "byteOffset") || // Skip index properties.
      a(_, b))) && m.push(_);
    return m;
  }
  return ni = c, ni;
}
var ai, Nu;
function Xm() {
  if (Nu) return ai;
  Nu = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return ai = t, ai;
}
var ii, Lu;
function Jm() {
  if (Lu) return ii;
  Lu = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return ii = e, ii;
}
var oi, ku;
function Zm() {
  if (ku) return oi;
  ku = 1;
  var e = Jm(), t = e(Object.keys, Object);
  return oi = t, oi;
}
var si, Vu;
function Qm() {
  if (Vu) return si;
  Vu = 1;
  var e = Xm(), t = Zm(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    if (!e(i))
      return t(i);
    var o = [];
    for (var s in Object(i))
      n.call(i, s) && s != "constructor" && o.push(s);
    return o;
  }
  return si = a, si;
}
var ci, Bu;
function So() {
  if (Bu) return ci;
  Bu = 1;
  var e = $f(), t = Ro();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return ci = r, ci;
}
var ui, Hu;
function Po() {
  if (Hu) return ui;
  Hu = 1;
  var e = Ym(), t = Qm(), r = So();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return ui = n, ui;
}
var li, zu;
function eb() {
  if (zu) return li;
  zu = 1;
  var e = Bm(), t = Um(), r = Po();
  function n(a) {
    return e(a, r, t);
  }
  return li = n, li;
}
var fi, Uu;
function tb() {
  if (Uu) return fi;
  Uu = 1;
  var e = eb(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(i, o, s, c, u, d) {
    var l = s & t, h = e(i), f = h.length, g = e(o), p = g.length;
    if (f != p && !l)
      return !1;
    for (var m = f; m--; ) {
      var b = h[m];
      if (!(l ? b in o : n.call(o, b)))
        return !1;
    }
    var _ = d.get(i), C = d.get(o);
    if (_ && C)
      return _ == o && C == i;
    var R = !0;
    d.set(i, o), d.set(o, i);
    for (var P = l; ++m < f; ) {
      b = h[m];
      var O = i[b], T = o[b];
      if (c)
        var x = l ? c(T, O, b, o, i, d) : c(O, T, b, i, o, d);
      if (!(x === void 0 ? O === T || u(O, T, s, c, d) : x)) {
        R = !1;
        break;
      }
      P || (P = b == "constructor");
    }
    if (R && !P) {
      var w = i.constructor, E = o.constructor;
      w != E && "constructor" in i && "constructor" in o && !(typeof w == "function" && w instanceof w && typeof E == "function" && E instanceof E) && (R = !1);
    }
    return d.delete(i), d.delete(o), R;
  }
  return fi = a, fi;
}
var di, Wu;
function rb() {
  if (Wu) return di;
  Wu = 1;
  var e = Qe(), t = Oe(), r = e(t, "DataView");
  return di = r, di;
}
var hi, Gu;
function nb() {
  if (Gu) return hi;
  Gu = 1;
  var e = Qe(), t = Oe(), r = e(t, "Promise");
  return hi = r, hi;
}
var pi, Ku;
function ab() {
  if (Ku) return pi;
  Ku = 1;
  var e = Qe(), t = Oe(), r = e(t, "Set");
  return pi = r, pi;
}
var vi, Yu;
function ib() {
  if (Yu) return vi;
  Yu = 1;
  var e = Qe(), t = Oe(), r = e(t, "WeakMap");
  return vi = r, vi;
}
var gi, Xu;
function ob() {
  if (Xu) return gi;
  Xu = 1;
  var e = rb(), t = _o(), r = nb(), n = ab(), a = ib(), i = Xe(), o = qf(), s = "[object Map]", c = "[object Object]", u = "[object Promise]", d = "[object Set]", l = "[object WeakMap]", h = "[object DataView]", f = o(e), g = o(t), p = o(r), m = o(n), b = o(a), _ = i;
  return (e && _(new e(new ArrayBuffer(1))) != h || t && _(new t()) != s || r && _(r.resolve()) != u || n && _(new n()) != d || a && _(new a()) != l) && (_ = function(C) {
    var R = i(C), P = R == c ? C.constructor : void 0, O = P ? o(P) : "";
    if (O)
      switch (O) {
        case f:
          return h;
        case g:
          return s;
        case p:
          return u;
        case m:
          return d;
        case b:
          return l;
      }
    return R;
  }), gi = _, gi;
}
var mi, Ju;
function sb() {
  if (Ju) return mi;
  Ju = 1;
  var e = Df(), t = Ff(), r = Vm(), n = tb(), a = ob(), i = Se(), o = Nf(), s = Lf(), c = 1, u = "[object Arguments]", d = "[object Array]", l = "[object Object]", h = Object.prototype, f = h.hasOwnProperty;
  function g(p, m, b, _, C, R) {
    var P = i(p), O = i(m), T = P ? d : a(p), x = O ? d : a(m);
    T = T == u ? l : T, x = x == u ? l : x;
    var w = T == l, E = x == l, S = T == x;
    if (S && o(p)) {
      if (!o(m))
        return !1;
      P = !0, w = !1;
    }
    if (S && !w)
      return R || (R = new e()), P || s(p) ? t(p, m, b, _, C, R) : r(p, m, T, b, _, C, R);
    if (!(b & c)) {
      var I = w && f.call(p, "__wrapped__"), $ = E && f.call(m, "__wrapped__");
      if (I || $) {
        var M = I ? p.value() : p, F = $ ? m.value() : m;
        return R || (R = new e()), C(M, F, b, _, R);
      }
    }
    return S ? (R || (R = new e()), n(p, m, b, _, C, R)) : !1;
  }
  return mi = g, mi;
}
var bi, Zu;
function Eo() {
  if (Zu) return bi;
  Zu = 1;
  var e = sb(), t = Je();
  function r(n, a, i, o, s) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, i, o, r, s);
  }
  return bi = r, bi;
}
var yi, Qu;
function cb() {
  if (Qu) return yi;
  Qu = 1;
  var e = Eo();
  function t(r, n) {
    return e(r, n);
  }
  return yi = t, yi;
}
var ub = cb();
const lb = /* @__PURE__ */ Re(ub);
var _i, el;
function fb() {
  if (el) return _i;
  el = 1;
  var e = Xe(), t = Je(), r = "[object Number]";
  function n(a) {
    return typeof a == "number" || t(a) && e(a) == r;
  }
  return _i = n, _i;
}
var db = fb();
const kf = /* @__PURE__ */ Re(db), hb = "_trigger_1mrk9_1", pb = {
  trigger: hb
}, vb = we(function({
  title: t,
  metrics: r,
  children: n
}) {
  const a = /* @__PURE__ */ y.jsxs(K, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "1", color: "inherit", children: t }),
    r.length > 0 && /* @__PURE__ */ y.jsx(ro, { bounded: !0, children: r.map((i, o) => /* @__PURE__ */ y.jsx(_f, { instrument: i, theme: "dark" }, o)) })
  ] });
  return /* @__PURE__ */ y.jsx(
    At,
    {
      content: a,
      wrap: "div",
      wrapProps: { className: pb.trigger },
      children: n
    }
  );
}), gb = "_cell_hfkay_1", mb = "_cellText_hfkay_11", bb = "_cellDimmed_hfkay_14", yb = "_cellContent_hfkay_18", wt = {
  cell: gb,
  cellText: mb,
  cellDimmed: bb,
  cellContent: yb
}, Wt = we(function({
  cell: t,
  dimmed: r = !1,
  background: n = "transparent",
  tooltipProps: a,
  textProps: i = {},
  onMouseEnter: o
}) {
  const [s, c] = Z(!1), u = ql(t?.value);
  Tt(() => {
    if (t?.value !== u) {
      c(!0);
      const h = setTimeout(() => {
        c(!1);
      }, 200);
      return () => {
        clearTimeout(h);
      };
    }
  }, [t?.value]);
  const d = Y(() => {
    if (!t) return null;
    const { value: h, format: f } = t;
    return typeof h == "string" ? h : typeof h == "number" && f ? qt(h, f) : "—";
  }, [t]);
  if (!t)
    return /* @__PURE__ */ y.jsx(
      "div",
      {
        className: wt.cell,
        onMouseEnter: o,
        "data-testid": "heatmap-instrument-cell"
      }
    );
  const l = /* @__PURE__ */ y.jsx("div", { className: wt.cellContent, children: /* @__PURE__ */ y.jsx(
    W.Paragraph,
    {
      className: $e({
        [wt.cellText]: typeof t.value == "string"
      }),
      variant: "3",
      subdued: !kf(t.value),
      ...i,
      children: d
    }
  ) });
  return /* @__PURE__ */ y.jsx(
    "div",
    {
      className: $e(wt.cell, {
        [wt.cellDimmed]: r || s
      }),
      onMouseEnter: o,
      style: { backgroundColor: n },
      "data-animating": s,
      "data-testid": "heatmap-instrument-cell",
      children: a?.enabled ? /* @__PURE__ */ y.jsx(vb, { ...a, children: l }) : l
    }
  );
}), _b = "_grid_1qk2p_1", xb = "_row_1qk2p_7", xi = {
  grid: _b,
  row: xb
};
var tl = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function wb(e, t) {
  return !!(e === t || tl(e) && tl(t));
}
function Cb(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!wb(e[r], t[r]))
      return !1;
  return !0;
}
function Rb(e, t) {
  t === void 0 && (t = Cb);
  var r = null;
  function n() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    if (r && r.lastThis === this && t(a, r.lastArgs))
      return r.lastResult;
    var o = e.apply(this, a);
    return r = {
      lastResult: o,
      lastArgs: a,
      lastThis: this
    }, o;
  }
  return n.clear = function() {
    r = null;
  }, n;
}
const Sb = [
  "100",
  "200",
  "400",
  "500",
  "700"
].map((e) => `var(--dixa-color-purple-${e})`), Pb = Rb(
  (e) => {
    if (e === null)
      return {
        backgroundColor: "var(--dixa-color-neutral-000)",
        color: "tertiary"
      };
    const t = Math.min(
      4,
      Math.floor(Math.min(e, 100) * (5 / 100))
    );
    return {
      backgroundColor: Sb?.[t] ?? "var(--dixa-color-neutral-000)",
      color: t >= 3 ? "white" : "primary"
    };
  }
);
function Eb(e) {
  return typeof e == "number" && !Number.isNaN(e) && e >= 0;
}
const Ob = (e) => {
  const t = e.flatMap(({ data: a }) => a.map((i) => dr(i).value)).filter(Eb), r = Math.min(...t), n = Math.max(...t);
  return { min: r, max: n };
}, Ab = (e, { min: t, max: r }) => t === r ? 100 : Math.round(100 * (e - t) / (r - t)), $y = ({
  instrument: e
}) => {
  const {
    data: { categories: t, series: r }
  } = e, n = ie(null), [a, i] = bd({
    cell: null,
    column: null,
    row: null
  }), o = Y(
    () => Object.values(a).some((f) => f !== null),
    [a]
  ), s = Y(() => Ob(r), [r]);
  ao(() => {
    const f = (g) => {
      n.current && !n.current.contains(g.target) && o && i.reset();
    };
    return window.addEventListener("mousemove", f, !0), () => {
      window.removeEventListener("mousemove", f, !0);
    };
  }, [o, i]);
  const c = G(
    (f) => {
      if (!o)
        return !1;
      const [g, p] = f;
      return a.cell ? !lb(a.cell.id, f) : a.column !== null ? a.column !== p : a.row !== null ? a.row !== g : !1;
    },
    [o, a.cell, a.column, a.row]
  ), u = G(
    (f) => i.setAll({
      cell: null,
      column: f,
      row: null
    }),
    [i]
  ), d = G(
    (f) => i.setAll({
      cell: null,
      column: null,
      row: f
    }),
    [i]
  ), l = G(
    (f) => {
      (o || f !== null) && i.setAll({
        cell: f,
        column: null,
        row: null
      });
    },
    [o, i]
  ), h = G(() => {
    o && i.reset();
  }, [o, i]);
  return /* @__PURE__ */ y.jsxs(
    "div",
    {
      ref: n,
      className: xi.grid,
      onMouseLeave: () => i.reset(),
      "data-testid": "heatmap-instrument",
      children: [
        /* @__PURE__ */ y.jsxs("div", { className: xi.row, children: [
          /* @__PURE__ */ y.jsx(Wt, { onMouseEnter: h }),
          r.map((f, g) => {
            const p = r[g].metrics ?? [];
            return /* @__PURE__ */ y.jsx(
              Wt,
              {
                cell: { id: [0, g], value: f.label },
                tooltipProps: {
                  enabled: p.length > 0,
                  title: f.label,
                  metrics: p
                },
                onMouseEnter: () => u(g)
              },
              f.label
            );
          })
        ] }),
        t.map((f, g) => {
          const p = t[g].metrics ?? [];
          return /* @__PURE__ */ y.jsxs("div", { className: xi.row, children: [
            /* @__PURE__ */ y.jsx(
              Wt,
              {
                cell: { id: [g, 0], value: f.label },
                tooltipProps: {
                  enabled: p.length > 0,
                  title: f.label,
                  metrics: p
                },
                onMouseEnter: () => d(g)
              }
            ),
            r.map((m, b) => {
              const _ = [g, b], { value: C, metrics: R } = dr(
                m.data[g]
              ), P = m.options?.format ?? "number", O = kf(C), { backgroundColor: T, color: x } = Pb(
                O ? Ab(C, s) : null
              );
              return /* @__PURE__ */ y.jsx(
                Wt,
                {
                  cell: { id: _, value: C, format: P },
                  dimmed: c(_),
                  background: T,
                  tooltipProps: {
                    enabled: O,
                    title: `${f.label}, ${m.label}`,
                    metrics: R?.length ? R : [
                      {
                        type: "metric",
                        title: "Total",
                        data: C,
                        format: P === "count" ? "number" : P
                      }
                    ]
                  },
                  textProps: { color: x },
                  onMouseEnter: () => l(O ? { id: _, value: C } : null)
                },
                _.join(",")
              );
            })
          ] }, f.label);
        })
      ]
    }
  );
}, Tb = "_legend_bx9pd_48", $b = "_trigger_bx9pd_52", qb = "_popover_bx9pd_58", jb = "_breakdown_bx9pd_77", Gt = {
  legend: Tb,
  trigger: $b,
  popover: qb,
  breakdown: jb
}, qy = we(function({
  instrument: t
}) {
  const {
    data: { availability: r, media_type: n, away: a }
  } = t, i = [
    "var(--dixa-color-purple-700)",
    "var(--dixa-color-neutral-200)"
  ], o = "No data available", s = {
    // Primitive way to ensure the labels are the same width, by deriving it from the longest
    // The number 7 is roughly the average width of a lowercase character
    labelWidth: Math.max(...n.map((l) => l.label.length)) * 7,
    theme: i
  }, c = () => /* @__PURE__ */ y.jsx(
    Jt,
    {
      ...s,
      value: 0,
      label: "n.a.",
      theme: ["var(--dixa-color-neutral-200)", "var(--dixa-color-neutral-200)"],
      showFullBar: !0
    }
  ), u = () => {
    if (!a || !a.length) return null;
    const [l, h, ...f] = a;
    return /* @__PURE__ */ y.jsxs(pf, { children: [
      /* @__PURE__ */ y.jsx(vf, { asChild: !0, children: /* @__PURE__ */ y.jsx(
        io,
        {
          variant: "tertiary",
          icon: "dots-h",
          className: Gt.trigger
        }
      ) }),
      /* @__PURE__ */ y.jsx(gf, { children: /* @__PURE__ */ y.jsx(mf, { side: "right", className: Gt.popover, children: /* @__PURE__ */ y.jsxs("ul", { className: Gt.breakdown, children: [
        /* @__PURE__ */ y.jsxs("li", { children: [
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "1", children: l.label }),
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "1", children: We(l.value) })
        ] }),
        /* @__PURE__ */ y.jsxs("li", { children: [
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "2", subdued: !0, children: h.label }),
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "2", subdued: !0, children: We(h.value) })
        ] }),
        /* @__PURE__ */ y.jsx(ld, {}),
        f.map((g, p) => /* @__PURE__ */ y.jsxs("li", { children: [
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "2", children: g.label }),
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "1", children: We(g.value) })
        ] }, p))
      ] }) }) })
    ] });
  }, d = () => /* @__PURE__ */ y.jsxs(K, { gap: "300", className: Gt.legend, children: [
    r.map((l, h) => /* @__PURE__ */ y.jsxs(K, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ y.jsx(
        oo,
        {
          width: "6px",
          height: "6px",
          background: i[h],
          borderRadius: "50%"
        }
      ),
      /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", children: l.label })
    ] }, h)),
    u()
  ] });
  return /* @__PURE__ */ y.jsxs(K, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ y.jsxs(K, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", subdued: !0, children: r.length ? "Availability" : o }),
      r.length ? /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        d(),
        /* @__PURE__ */ y.jsx(
          Jt,
          {
            ...s,
            value: r[0].value,
            label: "Total",
            showFullBar: !0,
            showDifference: !0
          }
        )
      ] }) : c()
    ] }),
    /* @__PURE__ */ y.jsxs(K, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", subdued: !0, children: n.length ? "Availability per channel" : o }),
      n.length > 0 ? /* @__PURE__ */ y.jsx(K, { flexDirection: "column", gap: "200", children: n.map((l, h) => /* @__PURE__ */ z(
        Jt,
        {
          ...s,
          key: h,
          value: l.value,
          label: l.label
        }
      )) }) : c()
    ] })
  ] });
}), Ib = "_tooltip_h4i5v_1", Mb = "_trigger_h4i5v_5", rl = {
  tooltip: Ib,
  trigger: Mb
}, Db = ({
  text: e
}) => /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
  /* @__PURE__ */ y.jsx("span", { children: e }),
  /* @__PURE__ */ y.jsx(
    At,
    {
      className: rl.tooltip,
      content: e,
      wrap: "div",
      wrapProps: { className: rl.trigger }
    }
  )
] }), Fb = we(
  function({
    value: t
  }) {
    const [r, ...n] = t;
    return /* @__PURE__ */ y.jsxs(K, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "2", as: "span", children: r }),
      n.length > 0 && /* @__PURE__ */ y.jsx(At, { content: n.join(", "), children: /* @__PURE__ */ y.jsxs(W.ExternalLink, { as: "span", children: [
        "+ ",
        n.length,
        " more"
      ] }) })
    ] });
  }
), Nb = ({
  cell: e,
  format: t,
  timezone: r,
  customFormats: n
}) => {
  const a = Y(() => {
    if (!e || Lb(e.value))
      return /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "2", color: "neutral.500", children: "n.a." });
    const { value: i, label: o } = e;
    if (o) return o;
    if (n?.[t])
      return n[t]?.({ value: i });
    switch (t) {
      case "boolean":
        return i ? "Y" : "N";
      case "date":
        return lt.tz(i, r).format("L, LT");
      case "count":
        return bf(i);
      case "number":
        return Ot(i);
      case "percentage":
        return `${Ot(i)}%`;
      case "duration":
        return We(i);
      case "csid":
        return `#${i}`;
      case "rating":
        return `${i}`;
      case "presence":
        return /* @__PURE__ */ y.jsx(Jt, { value: i, showFullBar: !0 });
      case "tags":
        return /* @__PURE__ */ y.jsx(Fd, { tags: i, limit: 1 });
      case "text":
        return /* @__PURE__ */ y.jsx(Db, { text: i });
      case "list":
        return /* @__PURE__ */ y.jsx(Fb, { value: i });
      case "string":
      default:
        return `${i}`;
    }
  }, [e, n, t, r]);
  return e?.ui?.type === "badge" ? /* @__PURE__ */ y.jsx(fd, { variant: e.ui.variant, size: "medium", children: /* @__PURE__ */ y.jsx(y.Fragment, { children: a }) }) : /* @__PURE__ */ y.jsx(y.Fragment, { children: a });
};
function Lb(e) {
  const t = e === null, r = typeof e == "string" && e.trim() === "", n = Array.isArray(e) && !e.length;
  return t || r || n;
}
const kb = "_tableWrapper_1xmkm_1", Vb = "_tableWrapperEmpty_1xmkm_4", Bb = "_thCell_1xmkm_8", Hb = "_tdCell_1xmkm_12", zb = "_tooltip_1xmkm_20", Ct = {
  tableWrapper: kb,
  tableWrapperEmpty: Vb,
  thCell: Bb,
  tdCell: Hb,
  tooltip: zb
};
var wi, nl;
function Ub() {
  if (nl) return wi;
  nl = 1;
  function e(t) {
    return t == null;
  }
  return wi = e, wi;
}
var Wb = Ub();
const Gb = /* @__PURE__ */ Re(Wb);
var Ci, al;
function Kb() {
  if (al) return Ci;
  al = 1;
  var e = Df(), t = Eo(), r = 1, n = 2;
  function a(i, o, s, c) {
    var u = s.length, d = u, l = !c;
    if (i == null)
      return !d;
    for (i = Object(i); u--; ) {
      var h = s[u];
      if (l && h[2] ? h[1] !== i[h[0]] : !(h[0] in i))
        return !1;
    }
    for (; ++u < d; ) {
      h = s[u];
      var f = h[0], g = i[f], p = h[1];
      if (l && h[2]) {
        if (g === void 0 && !(f in i))
          return !1;
      } else {
        var m = new e();
        if (c)
          var b = c(g, p, f, i, o, m);
        if (!(b === void 0 ? t(p, g, r | n, c, m) : b))
          return !1;
      }
    }
    return !0;
  }
  return Ci = a, Ci;
}
var Ri, il;
function Vf() {
  if (il) return Ri;
  il = 1;
  var e = Ze();
  function t(r) {
    return r === r && !e(r);
  }
  return Ri = t, Ri;
}
var Si, ol;
function Yb() {
  if (ol) return Si;
  ol = 1;
  var e = Vf(), t = Po();
  function r(n) {
    for (var a = t(n), i = a.length; i--; ) {
      var o = a[i], s = n[o];
      a[i] = [o, s, e(s)];
    }
    return a;
  }
  return Si = r, Si;
}
var Pi, sl;
function Bf() {
  if (sl) return Pi;
  sl = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return Pi = e, Pi;
}
var Ei, cl;
function Xb() {
  if (cl) return Ei;
  cl = 1;
  var e = Kb(), t = Yb(), r = Bf();
  function n(a) {
    var i = t(a);
    return i.length == 1 && i[0][2] ? r(i[0][0], i[0][1]) : function(o) {
      return o === a || e(o, a, i);
    };
  }
  return Ei = n, Ei;
}
var Oi, ul;
function Jb() {
  if (ul) return Oi;
  ul = 1;
  var e = _r();
  function t(r, n, a) {
    var i = r == null ? void 0 : e(r, n);
    return i === void 0 ? a : i;
  }
  return Oi = t, Oi;
}
var Ai, ll;
function Zb() {
  if (ll) return Ai;
  ll = 1;
  var e = Eo(), t = Jb(), r = If(), n = bo(), a = Vf(), i = Bf(), o = Mt(), s = 1, c = 2;
  function u(d, l) {
    return n(d) && a(l) ? i(o(d), l) : function(h) {
      var f = t(h, d);
      return f === void 0 && f === l ? r(h, d) : e(l, f, s | c);
    };
  }
  return Ai = u, Ai;
}
var Ti, fl;
function Qb() {
  if (fl) return Ti;
  fl = 1;
  var e = _r();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return Ti = t, Ti;
}
var $i, dl;
function ey() {
  if (dl) return $i;
  dl = 1;
  var e = Pf(), t = Qb(), r = bo(), n = Mt();
  function a(i) {
    return r(i) ? e(n(i)) : t(i);
  }
  return $i = a, $i;
}
var qi, hl;
function ty() {
  if (hl) return qi;
  hl = 1;
  var e = Xb(), t = Zb(), r = xr(), n = Se(), a = ey();
  function i(o) {
    return typeof o == "function" ? o : o == null ? r : typeof o == "object" ? n(o) ? t(o[0], o[1]) : e(o) : a(o);
  }
  return qi = i, qi;
}
var ji, pl;
function ry() {
  if (pl) return ji;
  pl = 1;
  function e(t) {
    return function(r, n, a) {
      for (var i = -1, o = Object(r), s = a(r), c = s.length; c--; ) {
        var u = s[t ? c : ++i];
        if (n(o[u], u, o) === !1)
          break;
      }
      return r;
    };
  }
  return ji = e, ji;
}
var Ii, vl;
function ny() {
  if (vl) return Ii;
  vl = 1;
  var e = ry(), t = e();
  return Ii = t, Ii;
}
var Mi, gl;
function ay() {
  if (gl) return Mi;
  gl = 1;
  var e = ny(), t = Po();
  function r(n, a) {
    return n && e(n, a, t);
  }
  return Mi = r, Mi;
}
var Di, ml;
function iy() {
  if (ml) return Di;
  ml = 1;
  var e = So();
  function t(r, n) {
    return function(a, i) {
      if (a == null)
        return a;
      if (!e(a))
        return r(a, i);
      for (var o = a.length, s = n ? o : -1, c = Object(a); (n ? s-- : ++s < o) && i(c[s], s, c) !== !1; )
        ;
      return a;
    };
  }
  return Di = t, Di;
}
var Fi, bl;
function oy() {
  if (bl) return Fi;
  bl = 1;
  var e = ay(), t = iy(), r = t(e);
  return Fi = r, Fi;
}
var Ni, yl;
function sy() {
  if (yl) return Ni;
  yl = 1;
  var e = oy(), t = So();
  function r(n, a) {
    var i = -1, o = t(n) ? Array(n.length) : [];
    return e(n, function(s, c, u) {
      o[++i] = a(s, c, u);
    }), o;
  }
  return Ni = r, Ni;
}
var Li, _l;
function cy() {
  if (_l) return Li;
  _l = 1;
  function e(t, r) {
    var n = t.length;
    for (t.sort(r); n--; )
      t[n] = t[n].value;
    return t;
  }
  return Li = e, Li;
}
var ki, xl;
function uy() {
  if (xl) return ki;
  xl = 1;
  var e = It();
  function t(r, n) {
    if (r !== n) {
      var a = r !== void 0, i = r === null, o = r === r, s = e(r), c = n !== void 0, u = n === null, d = n === n, l = e(n);
      if (!u && !l && !s && r > n || s && c && d && !u && !l || i && c && d || !a && d || !o)
        return 1;
      if (!i && !s && !l && r < n || l && a && o && !i && !s || u && a && o || !c && o || !d)
        return -1;
    }
    return 0;
  }
  return ki = t, ki;
}
var Vi, wl;
function ly() {
  if (wl) return Vi;
  wl = 1;
  var e = uy();
  function t(r, n, a) {
    for (var i = -1, o = r.criteria, s = n.criteria, c = o.length, u = a.length; ++i < c; ) {
      var d = e(o[i], s[i]);
      if (d) {
        if (i >= u)
          return d;
        var l = a[i];
        return d * (l == "desc" ? -1 : 1);
      }
    }
    return r.index - n.index;
  }
  return Vi = t, Vi;
}
var Bi, Cl;
function fy() {
  if (Cl) return Bi;
  Cl = 1;
  var e = wf(), t = _r(), r = ty(), n = sy(), a = cy(), i = mo(), o = ly(), s = xr(), c = Se();
  function u(d, l, h) {
    l.length ? l = e(l, function(p) {
      return c(p) ? function(m) {
        return t(m, p.length === 1 ? p[0] : p);
      } : p;
    }) : l = [s];
    var f = -1;
    l = e(l, i(r));
    var g = n(d, function(p, m, b) {
      var _ = e(l, function(C) {
        return C(p);
      });
      return { criteria: _, index: ++f, value: p };
    });
    return a(g, function(p, m) {
      return o(p, m, h);
    });
  }
  return Bi = u, Bi;
}
var Hi, Rl;
function dy() {
  if (Rl) return Hi;
  Rl = 1;
  var e = fy(), t = Se();
  function r(n, a, i, o) {
    return n == null ? [] : (t(a) || (a = a == null ? [] : [a]), i = o ? void 0 : i, t(i) || (i = i == null ? [] : [i]), e(n, a, i));
  }
  return Hi = r, Hi;
}
var hy = dy();
const py = /* @__PURE__ */ Re(hy), vy = (e) => typeof e == "string" || typeof e == "number" || typeof e == "boolean", Sl = (e, t) => {
  const r = e.cells.find((n) => n.column === t.key);
  return !r || r.value === null ? null : (vy(r.value), r.value);
}, gy = ({
  data: { columns: e, rows: t },
  limit: r = 50,
  sortStatus: n
}) => {
  const i = Math.ceil(t.length / r), [o, s] = Z(1);
  Tt(() => {
    o !== 1 && s(1);
  }, [n, i]);
  const c = Y(() => {
    if (!n) return t;
    const d = e.find(({ key: l }) => l === n.sortBy);
    return d ? py(
      t,
      [
        (l) => !Gb(Sl(l, d)),
        (l) => Sl(l, d)
      ],
      ["desc", n.direction]
    ) : t;
  }, [e, t, n]);
  return {
    rows: Y(
      () => c.slice((o - 1) * r, o * r),
      [o, r, c]
    ),
    currentPage: o,
    totalPages: i,
    setPage: s
  };
}, jy = ({
  instrument: e,
  timezone: t,
  onReadInstruments: r,
  onLoadAll: n,
  onSortChange: a,
  customFormats: i
}) => {
  const {
    title: o,
    data: s,
    data: { columns: c, options: u }
  } = e, [d, l] = Z(null), h = ie(null), f = u?.limit ?? 50, { rows: g, currentPage: p, totalPages: m, setPage: b } = gy({
    data: s,
    limit: f,
    sortStatus: d
  }), _ = s.rows.length === 0, C = !!u?.next_page, R = !C && m > 1;
  Tt(() => {
    h.current && (h.current.scrollTop = 0);
  }, [p]);
  const P = G(() => (n?.(), r({
    meta: {
      pagination: {
        limit: null
      }
    }
  })), [n, r]), O = G(
    async (T) => {
      C && await P(), l(T), a?.(T);
    },
    [P, a, C]
  );
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    o && /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(W.Heading, { variant: "heading-4", children: o }) }),
    /* @__PURE__ */ y.jsxs(
      Ce,
      {
        stickyHeader: !0,
        sortingProps: {
          sortStatus: d,
          onSortChange: O
        },
        wrapperProps: {
          className: $e(Ct.tableWrapper, {
            [Ct.tableWrapperEmpty]: _
          })
        },
        wrapperRef: h,
        hoverable: !_,
        children: [
          /* @__PURE__ */ y.jsx(Ce.Thead, { children: /* @__PURE__ */ y.jsx(Ce.Tr, { children: c.map(({ key: T, label: x, sortable: w }) => /* @__PURE__ */ y.jsx(
            Ce.Th,
            {
              className: Ct.thCell,
              columnId: w ? T : null,
              children: x
            },
            x
          )) }) }),
          /* @__PURE__ */ y.jsxs(Ce.Tbody, { children: [
            _ && /* @__PURE__ */ y.jsx(Ce.Tr, { children: /* @__PURE__ */ y.jsx(Ce.Td, { colSpan: c.length, children: /* @__PURE__ */ y.jsx(
              Tl,
              {
                title: "No data available",
                description: "There is no data available for the selected period and filters.",
                icon: "th"
              }
            ) }) }),
            g.map((T, x) => {
              const w = `row-${x}`;
              return /* @__PURE__ */ y.jsx(Ce.Tr, { children: c.map(({ key: E, format: S }, I) => {
                const $ = T.cells.find((M) => M.column === E);
                return /* @__PURE__ */ y.jsx(
                  Ce.Td,
                  {
                    className: Ct.tdCell,
                    children: /* @__PURE__ */ y.jsx(
                      Nb,
                      {
                        cell: $,
                        format: S,
                        timezone: t,
                        customFormats: i
                      }
                    )
                  },
                  `${w}-cell-${I}`
                );
              }) }, w);
            })
          ] }),
          C && /* @__PURE__ */ y.jsx(Ce.Footer, { children: /* @__PURE__ */ y.jsxs(K, { alignItems: "center", justifyContent: "center", gap: "300", children: [
            /* @__PURE__ */ y.jsxs(K, { gap: "100", alignItems: "center", children: [
              /* @__PURE__ */ y.jsx(
                dd,
                {
                  tooltipClassName: Ct.tooltip,
                  text: `By default we only load the first ${f} results. If you need to see all available results, click on the button, but beware that this may take a bit of time to load depending on the number of results.`
                }
              ),
              /* @__PURE__ */ y.jsxs(W.Paragraph, { variant: "2", children: [
                "Showing only the ",
                /* @__PURE__ */ y.jsxs("b", { children: [
                  "first ",
                  f,
                  " results"
                ] })
              ] })
            ] }),
            /* @__PURE__ */ y.jsx(Al, { variant: "secondary", onClick: P, children: "Load all results" })
          ] }) }),
          R && /* @__PURE__ */ y.jsx(Ce.Footer, { children: /* @__PURE__ */ y.jsx(K, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ y.jsx(
            hd,
            {
              pageCount: m,
              currentPage: p,
              pageRangeDisplayed: 6,
              onPageChange: b
            }
          ) }) })
        ]
      }
    )
  ] });
};
export {
  Oy as AnalyticsMenu,
  Ty as ChartInstrument,
  $y as HeatmapInstrument,
  _f as MetricInstrument,
  Fv as MetricInstrumentData,
  ro as MetricInstrumentsGrid,
  Jt as PercentageBar,
  qy as PresenceInstrument,
  jy as TableInstrument,
  Ay as categorizeInstruments,
  Ge as chartAppearance,
  bf as formatAbbreviateNumber,
  qt as formatInstrumentNumber,
  Ot as formatLocalizedNumber,
  We as formatMillisecondsToDuration,
  dr as getChartSeriesValue,
  Sv as isAIInsightInstrument,
  xv as isChartInstrument,
  or as isDateLikeString,
  wv as isHeatmapInstrument,
  _v as isMetricInstrument,
  Rv as isPresenceInstrument,
  Cv as isTableInstrument,
  vy as isTableInstrumentDataValuePrimitive,
  ct as resolveChartElementColor,
  yf as resolveInstrumentColor
};
//# sourceMappingURL=index.js.map
